const pkdex = [
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 49,
    "Abilities": [
      65,
      65,
      34
    ],
    "DEF": 49,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 45,
    "SPA": 65,
    "SPD": 65,
    "SPE": 45,
    "Species": 1
  },
  {
    "ATK": 62,
    "Abilities": [
      65,
      65,
      34
    ],
    "DEF": 63,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 60,
    "SPA": 80,
    "SPD": 80,
    "SPE": 60,
    "Species": 2
  },
  {
    "ATK": 82,
    "Abilities": [
      65,
      65,
      34
    ],
    "DEF": 83,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 80,
    "SPA": 100,
    "SPD": 100,
    "SPE": 80,
    "Species": 3
  },
  {
    "ATK": 52,
    "Abilities": [
      66,
      66,
      94
    ],
    "DEF": 43,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 39,
    "SPA": 60,
    "SPD": 50,
    "SPE": 65,
    "Species": 4
  },
  {
    "ATK": 64,
    "Abilities": [
      66,
      66,
      94
    ],
    "DEF": 58,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 58,
    "SPA": 80,
    "SPD": 65,
    "SPE": 80,
    "Species": 5
  },
  {
    "ATK": 84,
    "Abilities": [
      66,
      66,
      94
    ],
    "DEF": 78,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 78,
    "SPA": 109,
    "SPD": 85,
    "SPE": 100,
    "Species": 6
  },
  {
    "ATK": 48,
    "Abilities": [
      67,
      67,
      44
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 44,
    "SPA": 50,
    "SPD": 64,
    "SPE": 43,
    "Species": 7
  },
  {
    "ATK": 63,
    "Abilities": [
      67,
      67,
      44
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 59,
    "SPA": 65,
    "SPD": 80,
    "SPE": 58,
    "Species": 8
  },
  {
    "ATK": 83,
    "Abilities": [
      67,
      67,
      44
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 79,
    "SPA": 85,
    "SPD": 105,
    "SPE": 78,
    "Species": 9
  },
  {
    "ATK": 30,
    "Abilities": [
      19,
      19,
      50
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 20,
    "SPD": 20,
    "SPE": 45,
    "Species": 10
  },
  {
    "ATK": 20,
    "Abilities": [
      61,
      61,
      61
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 25,
    "SPD": 25,
    "SPE": 30,
    "Species": 11
  },
  {
    "ATK": 45,
    "Abilities": [
      14,
      14,
      110
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 90,
    "SPD": 80,
    "SPE": 70,
    "Species": 12
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 127,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 90,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 910,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 60,
    "SPA": 90,
    "SPD": 80,
    "SPE": 110,
    "Species": 26
  },
  {
    "ATK": 75,
    "Abilities": [
      8,
      8,
      146
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 911,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 50,
    "SPA": 20,
    "SPD": 30,
    "SPE": 40,
    "Species": 27
  },
  {
    "ATK": 100,
    "Abilities": [
      8,
      8,
      146
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 912,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 75,
    "SPA": 45,
    "SPD": 55,
    "SPE": 65,
    "Species": 28
  },
  {
    "ATK": 47,
    "Abilities": [
      38,
      79,
      55
    ],
    "DEF": 52,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 55,
    "SPA": 40,
    "SPD": 40,
    "SPE": 41,
    "Species": 29
  },
  {
    "ATK": 62,
    "Abilities": [
      38,
      79,
      55
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 70,
    "SPA": 55,
    "SPD": 55,
    "SPE": 56,
    "Species": 30
  },
  {
    "ATK": 92,
    "Abilities": [
      38,
      79,
      125
    ],
    "DEF": 87,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 90,
    "SPA": 75,
    "SPD": 85,
    "SPE": 76,
    "Species": 31
  },
  {
    "ATK": 57,
    "Abilities": [
      38,
      79,
      55
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 46,
    "SPA": 40,
    "SPD": 40,
    "SPE": 50,
    "Species": 32
  },
  {
    "ATK": 72,
    "Abilities": [
      38,
      79,
      55
    ],
    "DEF": 57,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 61,
    "SPA": 55,
    "SPD": 55,
    "SPE": 65,
    "Species": 33
  },
  {
    "ATK": 102,
    "Abilities": [
      38,
      79,
      125
    ],
    "DEF": 77,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 81,
    "SPA": 85,
    "SPD": 75,
    "SPE": 85,
    "Species": 34
  },
  {
    "ATK": 45,
    "Abilities": [
      56,
      98,
      132
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 70,
    "SPA": 60,
    "SPD": 65,
    "SPE": 35,
    "Species": 35
  },
  {
    "ATK": 70,
    "Abilities": [
      56,
      98,
      109
    ],
    "DEF": 73,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 95,
    "SPA": 95,
    "SPD": 90,
    "SPE": 60,
    "Species": 36
  },
  {
    "ATK": 41,
    "Abilities": [
      18,
      18,
      70
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 913,
    "FormeCount": 2,
    "Gender": 191,
    "HP": 38,
    "SPA": 50,
    "SPD": 65,
    "SPE": 65,
    "Species": 37
  },
  {
    "ATK": 76,
    "Abilities": [
      18,
      18,
      70
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 914,
    "FormeCount": 2,
    "Gender": 191,
    "HP": 73,
    "SPA": 81,
    "SPD": 100,
    "SPE": 100,
    "Species": 38
  },
  {
    "ATK": 45,
    "Abilities": [
      56,
      172,
      132
    ],
    "DEF": 20,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 115,
    "SPA": 45,
    "SPD": 25,
    "SPE": 20,
    "Species": 39
  },
  {
    "ATK": 70,
    "Abilities": [
      56,
      172,
      119
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 140,
    "SPA": 85,
    "SPD": 50,
    "SPE": 45,
    "Species": 40
  },
  {
    "ATK": 45,
    "Abilities": [
      39,
      39,
      151
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 30,
    "SPD": 40,
    "SPE": 55,
    "Species": 41
  },
  {
    "ATK": 80,
    "Abilities": [
      39,
      39,
      151
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 65,
    "SPD": 75,
    "SPE": 90,
    "Species": 42
  },
  {
    "ATK": 50,
    "Abilities": [
      34,
      34,
      50
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 75,
    "SPD": 65,
    "SPE": 30,
    "Species": 43
  },
  {
    "ATK": 65,
    "Abilities": [
      34,
      34,
      1
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 85,
    "SPD": 75,
    "SPE": 40,
    "Species": 44
  },
  {
    "ATK": 80,
    "Abilities": [
      34,
      34,
      27
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 110,
    "SPD": 90,
    "SPE": 50,
    "Species": 45
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      8,
      71,
      159
    ],
    "DEF": 25,
    "FormIndex": 0,
    "FormStatsIndex": 915,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 10,
    "SPA": 35,
    "SPD": 45,
    "SPE": 95,
    "Species": 50
  },
  {
    "ATK": 100,
    "Abilities": [
      8,
      71,
      159
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 916,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 35,
    "SPA": 50,
    "SPD": 70,
    "SPE": 120,
    "Species": 51
  },
  {
    "ATK": 45,
    "Abilities": [
      53,
      101,
      127
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 917,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 40,
    "SPA": 40,
    "SPD": 40,
    "SPE": 90,
    "Species": 52
  },
  {
    "ATK": 70,
    "Abilities": [
      7,
      101,
      127
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 919,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 65,
    "SPA": 65,
    "SPD": 65,
    "SPE": 115,
    "Species": 53
  },
  {
    "ATK": 52,
    "Abilities": [
      6,
      13,
      33
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 65,
    "SPD": 50,
    "SPE": 55,
    "Species": 54
  },
  {
    "ATK": 82,
    "Abilities": [
      6,
      13,
      33
    ],
    "DEF": 78,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 95,
    "SPD": 80,
    "SPE": 85,
    "Species": 55
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 70,
    "Abilities": [
      22,
      18,
      154
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 55,
    "SPA": 70,
    "SPD": 50,
    "SPE": 60,
    "Species": 58
  },
  {
    "ATK": 110,
    "Abilities": [
      22,
      18,
      154
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 90,
    "SPA": 100,
    "SPD": 80,
    "SPE": 95,
    "Species": 59
  },
  {
    "ATK": 50,
    "Abilities": [
      11,
      6,
      33
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 40,
    "SPD": 40,
    "SPE": 90,
    "Species": 60
  },
  {
    "ATK": 65,
    "Abilities": [
      11,
      6,
      33
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 61
  },
  {
    "ATK": 95,
    "Abilities": [
      11,
      6,
      33
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 70,
    "SPD": 90,
    "SPE": 70,
    "Species": 62
  },
  {
    "ATK": 20,
    "Abilities": [
      28,
      39,
      98
    ],
    "DEF": 15,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 25,
    "SPA": 105,
    "SPD": 55,
    "SPE": 90,
    "Species": 63
  },
  {
    "ATK": 35,
    "Abilities": [
      28,
      39,
      98
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 40,
    "SPA": 120,
    "SPD": 70,
    "SPE": 105,
    "Species": 64
  },
  {
    "ATK": 50,
    "Abilities": [
      28,
      39,
      98
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 55,
    "SPA": 135,
    "SPD": 95,
    "SPE": 120,
    "Species": 65
  },
  {
    "ATK": 80,
    "Abilities": [
      62,
      99,
      80
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 70,
    "SPA": 35,
    "SPD": 35,
    "SPE": 35,
    "Species": 66
  },
  {
    "ATK": 100,
    "Abilities": [
      62,
      99,
      80
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 80,
    "SPA": 50,
    "SPD": 60,
    "SPE": 45,
    "Species": 67
  },
  {
    "ATK": 130,
    "Abilities": [
      62,
      99,
      80
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 90,
    "SPA": 65,
    "SPD": 85,
    "SPE": 55,
    "Species": 68
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 40,
    "Abilities": [
      29,
      64,
      44
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 50,
    "SPD": 100,
    "SPE": 70,
    "Species": 72
  },
  {
    "ATK": 70,
    "Abilities": [
      29,
      64,
      44
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 80,
    "SPD": 120,
    "SPE": 100,
    "Species": 73
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 85,
    "Abilities": [
      50,
      18,
      49
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 923,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 50,
    "SPA": 65,
    "SPD": 65,
    "SPE": 90,
    "Species": 77
  },
  {
    "ATK": 100,
    "Abilities": [
      50,
      18,
      49
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 924,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 65,
    "SPA": 80,
    "SPD": 80,
    "SPE": 105,
    "Species": 78
  },
  {
    "ATK": 65,
    "Abilities": [
      12,
      20,
      144
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 925,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 90,
    "SPA": 40,
    "SPD": 40,
    "SPE": 15,
    "Species": 79
  },
  {
    "ATK": 75,
    "Abilities": [
      12,
      20,
      144
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 926,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 95,
    "SPA": 100,
    "SPD": 80,
    "SPE": 30,
    "Species": 80
  },
  {
    "ATK": 35,
    "Abilities": [
      42,
      5,
      148
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 25,
    "SPA": 95,
    "SPD": 55,
    "SPE": 45,
    "Species": 81
  },
  {
    "ATK": 60,
    "Abilities": [
      42,
      5,
      148
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 50,
    "SPA": 120,
    "SPD": 70,
    "SPE": 70,
    "Species": 82
  },
  {
    "ATK": 90,
    "Abilities": [
      51,
      39,
      128
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 928,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 52,
    "SPA": 58,
    "SPD": 62,
    "SPE": 60,
    "Species": 83
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 65,
    "Abilities": [
      75,
      92,
      142
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 45,
    "SPD": 25,
    "SPE": 40,
    "Species": 90
  },
  {
    "ATK": 95,
    "Abilities": [
      75,
      92,
      142
    ],
    "DEF": 180,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 85,
    "SPD": 45,
    "SPE": 70,
    "Species": 91
  },
  {
    "ATK": 35,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 100,
    "SPD": 35,
    "SPE": 80,
    "Species": 92
  },
  {
    "ATK": 50,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 115,
    "SPD": 55,
    "SPE": 95,
    "Species": 93
  },
  {
    "ATK": 65,
    "Abilities": [
      130,
      130,
      130
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 130,
    "SPD": 75,
    "SPE": 110,
    "Species": 94
  },
  {
    "ATK": 45,
    "Abilities": [
      69,
      5,
      133
    ],
    "DEF": 160,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 35,
    "SPA": 30,
    "SPD": 45,
    "SPE": 70,
    "Species": 95
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 105,
    "Abilities": [
      52,
      75,
      125
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 25,
    "SPD": 25,
    "SPE": 50,
    "Species": 98
  },
  {
    "ATK": 130,
    "Abilities": [
      52,
      75,
      125
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 50,
    "SPD": 50,
    "SPE": 75,
    "Species": 99
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 40,
    "Abilities": [
      34,
      34,
      139
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 60,
    "SPD": 45,
    "SPE": 40,
    "Species": 102
  },
  {
    "ATK": 95,
    "Abilities": [
      34,
      34,
      139
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 931,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 95,
    "SPA": 125,
    "SPD": 75,
    "SPE": 55,
    "Species": 103
  },
  {
    "ATK": 50,
    "Abilities": [
      69,
      31,
      4
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 40,
    "SPD": 50,
    "SPE": 35,
    "Species": 104
  },
  {
    "ATK": 80,
    "Abilities": [
      69,
      31,
      4
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 932,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 60,
    "SPA": 50,
    "SPD": 80,
    "SPE": 45,
    "Species": 105
  },
  {
    "ATK": 120,
    "Abilities": [
      7,
      120,
      84
    ],
    "DEF": 53,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 50,
    "SPA": 35,
    "SPD": 110,
    "SPE": 87,
    "Species": 106
  },
  {
    "ATK": 105,
    "Abilities": [
      51,
      89,
      39
    ],
    "DEF": 79,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 50,
    "SPA": 35,
    "SPD": 110,
    "SPE": 76,
    "Species": 107
  },
  {
    "ATK": 55,
    "Abilities": [
      20,
      12,
      13
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 60,
    "SPD": 75,
    "SPE": 30,
    "Species": 108
  },
  {
    "ATK": 65,
    "Abilities": [
      26,
      256,
      1
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 60,
    "SPD": 45,
    "SPE": 35,
    "Species": 109
  },
  {
    "ATK": 90,
    "Abilities": [
      26,
      256,
      1
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 933,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 65,
    "SPA": 85,
    "SPD": 70,
    "SPE": 60,
    "Species": 110
  },
  {
    "ATK": 85,
    "Abilities": [
      31,
      69,
      120
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 30,
    "SPD": 30,
    "SPE": 25,
    "Species": 111
  },
  {
    "ATK": 130,
    "Abilities": [
      31,
      69,
      120
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 105,
    "SPA": 45,
    "SPD": 45,
    "SPE": 40,
    "Species": 112
  },
  {
    "ATK": 5,
    "Abilities": [
      30,
      32,
      131
    ],
    "DEF": 5,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 250,
    "SPA": 35,
    "SPD": 105,
    "SPE": 50,
    "Species": 113
  },
  {
    "ATK": 55,
    "Abilities": [
      34,
      102,
      144
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 100,
    "SPD": 40,
    "SPE": 60,
    "Species": 114
  },
  {
    "ATK": 95,
    "Abilities": [
      48,
      113,
      39
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 105,
    "SPA": 40,
    "SPD": 80,
    "SPE": 90,
    "Species": 115
  },
  {
    "ATK": 40,
    "Abilities": [
      33,
      97,
      6
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 70,
    "SPD": 25,
    "SPE": 60,
    "Species": 116
  },
  {
    "ATK": 65,
    "Abilities": [
      38,
      97,
      6
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 95,
    "SPD": 45,
    "SPE": 85,
    "Species": 117
  },
  {
    "ATK": 67,
    "Abilities": [
      33,
      41,
      31
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 35,
    "SPD": 50,
    "SPE": 63,
    "Species": 118
  },
  {
    "ATK": 92,
    "Abilities": [
      33,
      41,
      31
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 65,
    "SPD": 80,
    "SPE": 68,
    "Species": 119
  },
  {
    "ATK": 45,
    "Abilities": [
      35,
      30,
      148
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 30,
    "SPA": 70,
    "SPD": 55,
    "SPE": 85,
    "Species": 120
  },
  {
    "ATK": 75,
    "Abilities": [
      35,
      30,
      148
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 60,
    "SPA": 100,
    "SPD": 85,
    "SPE": 115,
    "Species": 121
  },
  {
    "ATK": 45,
    "Abilities": [
      43,
      111,
      101
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 934,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 40,
    "SPA": 100,
    "SPD": 120,
    "SPE": 90,
    "Species": 122
  },
  {
    "ATK": 110,
    "Abilities": [
      68,
      101,
      80
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 55,
    "SPD": 80,
    "SPE": 105,
    "Species": 123
  },
  {
    "ATK": 50,
    "Abilities": [
      12,
      108,
      87
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 65,
    "SPA": 115,
    "SPD": 95,
    "SPE": 95,
    "Species": 124
  },
  {
    "ATK": 83,
    "Abilities": [
      9,
      9,
      72
    ],
    "DEF": 57,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 65,
    "SPA": 95,
    "SPD": 85,
    "SPE": 105,
    "Species": 125
  },
  {
    "ATK": 95,
    "Abilities": [
      49,
      49,
      72
    ],
    "DEF": 57,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 65,
    "SPA": 100,
    "SPD": 85,
    "SPE": 93,
    "Species": 126
  },
  {
    "ATK": 125,
    "Abilities": [
      52,
      104,
      153
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 55,
    "SPD": 70,
    "SPE": 85,
    "Species": 127
  },
  {
    "ATK": 100,
    "Abilities": [
      22,
      83,
      125
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 75,
    "SPA": 40,
    "SPD": 70,
    "SPE": 110,
    "Species": 128
  },
  {
    "ATK": 10,
    "Abilities": [
      33,
      33,
      155
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 20,
    "SPA": 15,
    "SPD": 20,
    "SPE": 80,
    "Species": 129
  },
  {
    "ATK": 125,
    "Abilities": [
      22,
      22,
      153
    ],
    "DEF": 79,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 60,
    "SPD": 100,
    "SPE": 81,
    "Species": 130
  },
  {
    "ATK": 85,
    "Abilities": [
      11,
      75,
      93
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 130,
    "SPA": 85,
    "SPD": 95,
    "SPE": 60,
    "Species": 131
  },
  {
    "ATK": 48,
    "Abilities": [
      7,
      7,
      150
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 48,
    "SPA": 48,
    "SPD": 48,
    "SPE": 48,
    "Species": 132
  },
  {
    "ATK": 55,
    "Abilities": [
      50,
      91,
      107
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 55,
    "SPA": 45,
    "SPD": 65,
    "SPE": 55,
    "Species": 133
  },
  {
    "ATK": 65,
    "Abilities": [
      11,
      11,
      93
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 130,
    "SPA": 110,
    "SPD": 95,
    "SPE": 65,
    "Species": 134
  },
  {
    "ATK": 65,
    "Abilities": [
      10,
      10,
      95
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 110,
    "SPD": 95,
    "SPE": 130,
    "Species": 135
  },
  {
    "ATK": 130,
    "Abilities": [
      18,
      18,
      62
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 95,
    "SPD": 110,
    "SPE": 65,
    "Species": 136
  },
  {
    "ATK": 60,
    "Abilities": [
      36,
      88,
      148
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 65,
    "SPA": 85,
    "SPD": 75,
    "SPE": 40,
    "Species": 137
  },
  {
    "ATK": 40,
    "Abilities": [
      33,
      75,
      133
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 35,
    "SPA": 90,
    "SPD": 55,
    "SPE": 35,
    "Species": 138
  },
  {
    "ATK": 60,
    "Abilities": [
      33,
      75,
      133
    ],
    "DEF": 125,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 70,
    "SPA": 115,
    "SPD": 70,
    "SPE": 55,
    "Species": 139
  },
  {
    "ATK": 80,
    "Abilities": [
      33,
      4,
      133
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 30,
    "SPA": 55,
    "SPD": 45,
    "SPE": 55,
    "Species": 140
  },
  {
    "ATK": 115,
    "Abilities": [
      33,
      4,
      133
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 60,
    "SPA": 65,
    "SPD": 70,
    "SPE": 80,
    "Species": 141
  },
  {
    "ATK": 105,
    "Abilities": [
      69,
      46,
      127
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 80,
    "SPA": 60,
    "SPD": 75,
    "SPE": 130,
    "Species": 142
  },
  {
    "ATK": 110,
    "Abilities": [
      17,
      47,
      82
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 160,
    "SPA": 65,
    "SPD": 110,
    "SPE": 30,
    "Species": 143
  },
  {
    "ATK": 85,
    "Abilities": [
      46,
      46,
      81
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 935,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 90,
    "SPA": 95,
    "SPD": 125,
    "SPE": 85,
    "Species": 144
  },
  {
    "ATK": 90,
    "Abilities": [
      46,
      46,
      9
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 936,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 90,
    "SPA": 125,
    "SPD": 90,
    "SPE": 100,
    "Species": 145
  },
  {
    "ATK": 100,
    "Abilities": [
      46,
      46,
      49
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 937,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 90,
    "SPA": 125,
    "SPD": 85,
    "SPE": 90,
    "Species": 146
  },
  {
    "ATK": 64,
    "Abilities": [
      61,
      61,
      63
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 41,
    "SPA": 50,
    "SPD": 50,
    "SPE": 50,
    "Species": 147
  },
  {
    "ATK": 84,
    "Abilities": [
      61,
      61,
      63
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 61,
    "SPA": 70,
    "SPD": 70,
    "SPE": 70,
    "Species": 148
  },
  {
    "ATK": 134,
    "Abilities": [
      39,
      39,
      136
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 91,
    "SPA": 100,
    "SPD": 100,
    "SPE": 80,
    "Species": 149
  },
  {
    "ATK": 110,
    "Abilities": [
      46,
      46,
      127
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 106,
    "SPA": 154,
    "SPD": 90,
    "SPE": 130,
    "Species": 150
  },
  {
    "ATK": 100,
    "Abilities": [
      28,
      28,
      28
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 100,
    "SPD": 100,
    "SPE": 100,
    "Species": 151
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 30,
    "Abilities": [
      15,
      51,
      110
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 36,
    "SPD": 56,
    "SPE": 50,
    "Species": 163
  },
  {
    "ATK": 50,
    "Abilities": [
      15,
      51,
      110
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 86,
    "SPD": 96,
    "SPE": 70,
    "Species": 164
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 90,
    "Abilities": [
      39,
      39,
      151
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 70,
    "SPD": 80,
    "SPE": 130,
    "Species": 169
  },
  {
    "ATK": 38,
    "Abilities": [
      10,
      35,
      11
    ],
    "DEF": 38,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 56,
    "SPD": 56,
    "SPE": 67,
    "Species": 170
  },
  {
    "ATK": 58,
    "Abilities": [
      10,
      35,
      11
    ],
    "DEF": 58,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 125,
    "SPA": 76,
    "SPD": 76,
    "SPE": 67,
    "Species": 171
  },
  {
    "ATK": 40,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 15,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 20,
    "SPA": 35,
    "SPD": 35,
    "SPE": 60,
    "Species": 172
  },
  {
    "ATK": 25,
    "Abilities": [
      56,
      98,
      132
    ],
    "DEF": 28,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 50,
    "SPA": 45,
    "SPD": 55,
    "SPE": 15,
    "Species": 173
  },
  {
    "ATK": 30,
    "Abilities": [
      56,
      172,
      132
    ],
    "DEF": 15,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 90,
    "SPA": 40,
    "SPD": 20,
    "SPE": 15,
    "Species": 174
  },
  {
    "ATK": 20,
    "Abilities": [
      55,
      32,
      105
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 35,
    "SPA": 40,
    "SPD": 65,
    "SPE": 20,
    "Species": 175
  },
  {
    "ATK": 40,
    "Abilities": [
      55,
      32,
      105
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 55,
    "SPA": 80,
    "SPD": 105,
    "SPE": 40,
    "Species": 176
  },
  {
    "ATK": 50,
    "Abilities": [
      28,
      48,
      156
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 70,
    "SPD": 45,
    "SPE": 70,
    "Species": 177
  },
  {
    "ATK": 75,
    "Abilities": [
      28,
      48,
      156
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 95,
    "SPD": 70,
    "SPE": 95,
    "Species": 178
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 80,
    "Abilities": [
      34,
      34,
      131
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 90,
    "SPD": 100,
    "SPE": 50,
    "Species": 182
  },
  {
    "ATK": 20,
    "Abilities": [
      47,
      37,
      157
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 20,
    "SPD": 50,
    "SPE": 40,
    "Species": 183
  },
  {
    "ATK": 50,
    "Abilities": [
      47,
      37,
      157
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 60,
    "SPD": 80,
    "SPE": 50,
    "Species": 184
  },
  {
    "ATK": 100,
    "Abilities": [
      5,
      69,
      155
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 30,
    "SPD": 65,
    "SPE": 30,
    "Species": 185
  },
  {
    "ATK": 75,
    "Abilities": [
      11,
      6,
      2
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 90,
    "SPD": 100,
    "SPE": 70,
    "Species": 186
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 45,
    "Abilities": [
      6,
      11,
      109
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 25,
    "SPD": 25,
    "SPE": 15,
    "Species": 194
  },
  {
    "ATK": 85,
    "Abilities": [
      6,
      11,
      109
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 65,
    "SPD": 65,
    "SPE": 35,
    "Species": 195
  },
  {
    "ATK": 65,
    "Abilities": [
      28,
      28,
      156
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 130,
    "SPD": 95,
    "SPE": 110,
    "Species": 196
  },
  {
    "ATK": 65,
    "Abilities": [
      28,
      28,
      39
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 95,
    "SPA": 60,
    "SPD": 130,
    "SPE": 65,
    "Species": 197
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 75,
    "Abilities": [
      12,
      20,
      144
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 938,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 95,
    "SPA": 100,
    "SPD": 110,
    "SPE": 30,
    "Species": 199
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 33,
    "Abilities": [
      23,
      23,
      140
    ],
    "DEF": 58,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 190,
    "SPA": 33,
    "SPD": 58,
    "SPE": 33,
    "Species": 202
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 70,
    "Abilities": [
      32,
      50,
      155
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 65,
    "SPD": 65,
    "SPE": 45,
    "Species": 206
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 85,
    "Abilities": [
      69,
      5,
      125
    ],
    "DEF": 200,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 55,
    "SPD": 65,
    "SPE": 30,
    "Species": 208
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 95,
    "Abilities": [
      38,
      33,
      22
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 55,
    "SPD": 55,
    "SPE": 85,
    "Species": 211
  },
  {
    "ATK": 130,
    "Abilities": [
      68,
      101,
      135
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 55,
    "SPD": 80,
    "SPE": 65,
    "Species": 212
  },
  {
    "ATK": 10,
    "Abilities": [
      5,
      82,
      126
    ],
    "DEF": 230,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 20,
    "SPA": 10,
    "SPD": 230,
    "SPE": 5,
    "Species": 213
  },
  {
    "ATK": 125,
    "Abilities": [
      68,
      62,
      153
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 40,
    "SPD": 95,
    "SPE": 85,
    "Species": 214
  },
  {
    "ATK": 95,
    "Abilities": [
      39,
      51,
      124
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 35,
    "SPD": 75,
    "SPE": 115,
    "Species": 215
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 50,
    "Abilities": [
      12,
      81,
      47
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 30,
    "SPD": 30,
    "SPE": 50,
    "Species": 220
  },
  {
    "ATK": 100,
    "Abilities": [
      12,
      81,
      47
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 60,
    "SPD": 60,
    "SPE": 50,
    "Species": 221
  },
  {
    "ATK": 55,
    "Abilities": [
      55,
      30,
      144
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 966,
    "FormeCount": 2,
    "Gender": 191,
    "HP": 65,
    "SPA": 65,
    "SPD": 95,
    "SPE": 35,
    "Species": 222
  },
  {
    "ATK": 65,
    "Abilities": [
      55,
      97,
      141
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 35,
    "SPA": 65,
    "SPD": 35,
    "SPE": 65,
    "Species": 223
  },
  {
    "ATK": 105,
    "Abilities": [
      21,
      97,
      141
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 105,
    "SPD": 75,
    "SPE": 45,
    "Species": 224
  },
  {
    "ATK": 55,
    "Abilities": [
      72,
      55,
      15
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 65,
    "SPD": 45,
    "SPE": 75,
    "Species": 225
  },
  {
    "ATK": 40,
    "Abilities": [
      33,
      11,
      41
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 80,
    "SPD": 140,
    "SPE": 70,
    "Species": 226
  },
  {
    "ATK": 80,
    "Abilities": [
      51,
      5,
      133
    ],
    "DEF": 140,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 40,
    "SPD": 70,
    "SPE": 70,
    "Species": 227
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 95,
    "Abilities": [
      33,
      97,
      6
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 95,
    "SPD": 95,
    "SPE": 85,
    "Species": 230
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 80,
    "Abilities": [
      36,
      88,
      148
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 85,
    "SPA": 105,
    "SPD": 95,
    "SPE": 60,
    "Species": 233
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 35,
    "Abilities": [
      62,
      80,
      72
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 35,
    "SPA": 35,
    "SPD": 35,
    "SPE": 35,
    "Species": 236
  },
  {
    "ATK": 95,
    "Abilities": [
      22,
      101,
      80
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 50,
    "SPA": 35,
    "SPD": 110,
    "SPE": 70,
    "Species": 237
  },
  {
    "ATK": 30,
    "Abilities": [
      12,
      108,
      93
    ],
    "DEF": 15,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 45,
    "SPA": 85,
    "SPD": 65,
    "SPE": 65,
    "Species": 238
  },
  {
    "ATK": 63,
    "Abilities": [
      9,
      9,
      72
    ],
    "DEF": 37,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 45,
    "SPA": 65,
    "SPD": 55,
    "SPE": 95,
    "Species": 239
  },
  {
    "ATK": 75,
    "Abilities": [
      49,
      49,
      72
    ],
    "DEF": 37,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 45,
    "SPA": 70,
    "SPD": 55,
    "SPE": 83,
    "Species": 240
  },
  {
    "ATK": 80,
    "Abilities": [
      47,
      113,
      157
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 95,
    "SPA": 40,
    "SPD": 70,
    "SPE": 100,
    "Species": 241
  },
  {
    "ATK": 10,
    "Abilities": [
      30,
      32,
      131
    ],
    "DEF": 10,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 255,
    "SPA": 75,
    "SPD": 135,
    "SPE": 55,
    "Species": 242
  },
  {
    "ATK": 85,
    "Abilities": [
      46,
      46,
      39
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 115,
    "SPD": 100,
    "SPE": 115,
    "Species": 243
  },
  {
    "ATK": 115,
    "Abilities": [
      46,
      46,
      39
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 115,
    "SPA": 90,
    "SPD": 75,
    "SPE": 100,
    "Species": 244
  },
  {
    "ATK": 75,
    "Abilities": [
      46,
      46,
      39
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 90,
    "SPD": 115,
    "SPE": 85,
    "Species": 245
  },
  {
    "ATK": 64,
    "Abilities": [
      62,
      62,
      8
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 45,
    "SPD": 50,
    "SPE": 41,
    "Species": 246
  },
  {
    "ATK": 84,
    "Abilities": [
      61,
      61,
      61
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 65,
    "SPD": 70,
    "SPE": 51,
    "Species": 247
  },
  {
    "ATK": 134,
    "Abilities": [
      45,
      45,
      127
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 95,
    "SPD": 100,
    "SPE": 61,
    "Species": 248
  },
  {
    "ATK": 90,
    "Abilities": [
      46,
      46,
      136
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 106,
    "SPA": 90,
    "SPD": 154,
    "SPE": 110,
    "Species": 249
  },
  {
    "ATK": 130,
    "Abilities": [
      46,
      46,
      144
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 106,
    "SPA": 110,
    "SPD": 154,
    "SPE": 90,
    "Species": 250
  },
  {
    "ATK": 100,
    "Abilities": [
      30,
      30,
      30
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 100,
    "SPD": 100,
    "SPE": 100,
    "Species": 251
  },
  {
    "ATK": 45,
    "Abilities": [
      65,
      65,
      84
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 40,
    "SPA": 65,
    "SPD": 55,
    "SPE": 70,
    "Species": 252
  },
  {
    "ATK": 65,
    "Abilities": [
      65,
      65,
      84
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 50,
    "SPA": 85,
    "SPD": 65,
    "SPE": 95,
    "Species": 253
  },
  {
    "ATK": 85,
    "Abilities": [
      65,
      65,
      84
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 70,
    "SPA": 105,
    "SPD": 85,
    "SPE": 120,
    "Species": 254
  },
  {
    "ATK": 60,
    "Abilities": [
      66,
      66,
      3
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 45,
    "SPA": 70,
    "SPD": 50,
    "SPE": 45,
    "Species": 255
  },
  {
    "ATK": 85,
    "Abilities": [
      66,
      66,
      3
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 60,
    "SPA": 85,
    "SPD": 60,
    "SPE": 55,
    "Species": 256
  },
  {
    "ATK": 120,
    "Abilities": [
      66,
      66,
      3
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 80,
    "SPA": 110,
    "SPD": 70,
    "SPE": 80,
    "Species": 257
  },
  {
    "ATK": 70,
    "Abilities": [
      67,
      67,
      6
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 50,
    "SPA": 50,
    "SPD": 50,
    "SPE": 40,
    "Species": 258
  },
  {
    "ATK": 85,
    "Abilities": [
      67,
      67,
      6
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 70,
    "SPA": 60,
    "SPD": 70,
    "SPE": 50,
    "Species": 259
  },
  {
    "ATK": 110,
    "Abilities": [
      67,
      67,
      6
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 100,
    "SPA": 85,
    "SPD": 90,
    "SPE": 60,
    "Species": 260
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 30,
    "Abilities": [
      53,
      82,
      95
    ],
    "DEF": 41,
    "FormIndex": 0,
    "FormStatsIndex": 967,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 38,
    "SPA": 30,
    "SPD": 41,
    "SPE": 60,
    "Species": 263
  },
  {
    "ATK": 70,
    "Abilities": [
      53,
      82,
      95
    ],
    "DEF": 61,
    "FormIndex": 0,
    "FormStatsIndex": 968,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 78,
    "SPA": 50,
    "SPD": 61,
    "SPE": 100,
    "Species": 264
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 30,
    "Abilities": [
      33,
      44,
      20
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 40,
    "SPD": 50,
    "SPE": 30,
    "Species": 270
  },
  {
    "ATK": 50,
    "Abilities": [
      33,
      44,
      20
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 60,
    "SPD": 70,
    "SPE": 50,
    "Species": 271
  },
  {
    "ATK": 70,
    "Abilities": [
      33,
      44,
      20
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 90,
    "SPD": 100,
    "SPE": 70,
    "Species": 272
  },
  {
    "ATK": 40,
    "Abilities": [
      34,
      48,
      124
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 30,
    "SPD": 30,
    "SPE": 30,
    "Species": 273
  },
  {
    "ATK": 70,
    "Abilities": [
      34,
      48,
      124
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 60,
    "SPD": 40,
    "SPE": 60,
    "Species": 274
  },
  {
    "ATK": 100,
    "Abilities": [
      34,
      48,
      124
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 90,
    "SPD": 60,
    "SPE": 80,
    "Species": 275
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 30,
    "Abilities": [
      51,
      93,
      44
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 55,
    "SPD": 30,
    "SPE": 85,
    "Species": 278
  },
  {
    "ATK": 50,
    "Abilities": [
      51,
      2,
      44
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 95,
    "SPD": 70,
    "SPE": 65,
    "Species": 279
  },
  {
    "ATK": 25,
    "Abilities": [
      28,
      36,
      140
    ],
    "DEF": 25,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 28,
    "SPA": 45,
    "SPD": 35,
    "SPE": 40,
    "Species": 280
  },
  {
    "ATK": 35,
    "Abilities": [
      28,
      36,
      140
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 38,
    "SPA": 65,
    "SPD": 55,
    "SPE": 50,
    "Species": 281
  },
  {
    "ATK": 65,
    "Abilities": [
      28,
      36,
      140
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 125,
    "SPD": 115,
    "SPE": 80,
    "Species": 282
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 45,
    "Abilities": [
      14,
      14,
      50
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 31,
    "SPA": 30,
    "SPD": 30,
    "SPE": 40,
    "Species": 290
  },
  {
    "ATK": 90,
    "Abilities": [
      3,
      3,
      151
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 61,
    "SPA": 50,
    "SPD": 50,
    "SPE": 160,
    "Species": 291
  },
  {
    "ATK": 90,
    "Abilities": [
      25,
      25,
      25
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 1,
    "SPA": 30,
    "SPD": 30,
    "SPE": 40,
    "Species": 292
  },
  {
    "ATK": 51,
    "Abilities": [
      43,
      43,
      155
    ],
    "DEF": 23,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 64,
    "SPA": 51,
    "SPD": 23,
    "SPE": 28,
    "Species": 293
  },
  {
    "ATK": 71,
    "Abilities": [
      43,
      43,
      113
    ],
    "DEF": 43,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 84,
    "SPA": 71,
    "SPD": 43,
    "SPE": 48,
    "Species": 294
  },
  {
    "ATK": 91,
    "Abilities": [
      43,
      43,
      113
    ],
    "DEF": 63,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 104,
    "SPA": 91,
    "SPD": 73,
    "SPE": 68,
    "Species": 295
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 20,
    "Abilities": [
      47,
      37,
      157
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 50,
    "SPA": 20,
    "SPD": 40,
    "SPE": 20,
    "Species": 298
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 75,
    "Abilities": [
      51,
      100,
      158
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 65,
    "SPD": 65,
    "SPE": 50,
    "Species": 302
  },
  {
    "ATK": 85,
    "Abilities": [
      52,
      22,
      125
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 55,
    "SPD": 55,
    "SPE": 50,
    "Species": 303
  },
  {
    "ATK": 70,
    "Abilities": [
      5,
      69,
      134
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 40,
    "SPD": 40,
    "SPE": 30,
    "Species": 304
  },
  {
    "ATK": 90,
    "Abilities": [
      5,
      69,
      134
    ],
    "DEF": 140,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 50,
    "SPD": 50,
    "SPE": 40,
    "Species": 305
  },
  {
    "ATK": 110,
    "Abilities": [
      5,
      69,
      134
    ],
    "DEF": 180,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 60,
    "SPD": 60,
    "SPE": 50,
    "Species": 306
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 45,
    "Abilities": [
      9,
      31,
      58
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 65,
    "SPD": 40,
    "SPE": 65,
    "Species": 309
  },
  {
    "ATK": 75,
    "Abilities": [
      9,
      31,
      58
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 105,
    "SPD": 60,
    "SPE": 105,
    "Species": 310
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 60,
    "Abilities": [
      30,
      38,
      102
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 100,
    "SPD": 80,
    "SPE": 65,
    "Species": 315
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 90,
    "Abilities": [
      24,
      24,
      3
    ],
    "DEF": 20,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 65,
    "SPD": 20,
    "SPE": 65,
    "Species": 318
  },
  {
    "ATK": 120,
    "Abilities": [
      24,
      24,
      3
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 95,
    "SPD": 40,
    "SPE": 95,
    "Species": 319
  },
  {
    "ATK": 70,
    "Abilities": [
      41,
      12,
      46
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 130,
    "SPA": 70,
    "SPD": 35,
    "SPE": 60,
    "Species": 320
  },
  {
    "ATK": 90,
    "Abilities": [
      41,
      12,
      46
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 170,
    "SPA": 90,
    "SPD": 45,
    "SPE": 60,
    "Species": 321
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 85,
    "Abilities": [
      73,
      70,
      75
    ],
    "DEF": 140,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 85,
    "SPD": 70,
    "SPE": 20,
    "Species": 324
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 100,
    "Abilities": [
      52,
      71,
      125
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 45,
    "SPD": 45,
    "SPE": 10,
    "Species": 328
  },
  {
    "ATK": 70,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 50,
    "SPD": 50,
    "SPE": 70,
    "Species": 329
  },
  {
    "ATK": 100,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 80,
    "SPD": 80,
    "SPE": 100,
    "Species": 330
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 40,
    "Abilities": [
      30,
      30,
      13
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 40,
    "SPD": 75,
    "SPE": 50,
    "Species": 333
  },
  {
    "ATK": 70,
    "Abilities": [
      30,
      30,
      13
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 70,
    "SPD": 105,
    "SPE": 80,
    "Species": 334
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 95,
    "SPD": 85,
    "SPE": 70,
    "Species": 337
  },
  {
    "ATK": 95,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 55,
    "SPD": 65,
    "SPE": 70,
    "Species": 338
  },
  {
    "ATK": 48,
    "Abilities": [
      12,
      107,
      93
    ],
    "DEF": 43,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 46,
    "SPD": 41,
    "SPE": 60,
    "Species": 339
  },
  {
    "ATK": 78,
    "Abilities": [
      12,
      107,
      93
    ],
    "DEF": 73,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 76,
    "SPD": 71,
    "SPE": 60,
    "Species": 340
  },
  {
    "ATK": 80,
    "Abilities": [
      52,
      75,
      91
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 43,
    "SPA": 50,
    "SPD": 35,
    "SPE": 35,
    "Species": 341
  },
  {
    "ATK": 120,
    "Abilities": [
      52,
      75,
      91
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 63,
    "SPA": 90,
    "SPD": 55,
    "SPE": 55,
    "Species": 342
  },
  {
    "ATK": 40,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 40,
    "SPA": 40,
    "SPD": 70,
    "SPE": 55,
    "Species": 343
  },
  {
    "ATK": 70,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 60,
    "SPA": 70,
    "SPD": 120,
    "SPE": 75,
    "Species": 344
  },
  {
    "ATK": 41,
    "Abilities": [
      21,
      21,
      114
    ],
    "DEF": 77,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 66,
    "SPA": 61,
    "SPD": 87,
    "SPE": 23,
    "Species": 345
  },
  {
    "ATK": 81,
    "Abilities": [
      21,
      21,
      114
    ],
    "DEF": 97,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 86,
    "SPA": 81,
    "SPD": 107,
    "SPE": 43,
    "Species": 346
  },
  {
    "ATK": 95,
    "Abilities": [
      4,
      4,
      33
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 45,
    "SPA": 40,
    "SPD": 50,
    "SPE": 75,
    "Species": 347
  },
  {
    "ATK": 125,
    "Abilities": [
      4,
      4,
      33
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 75,
    "SPA": 70,
    "SPD": 80,
    "SPE": 45,
    "Species": 348
  },
  {
    "ATK": 15,
    "Abilities": [
      33,
      12,
      91
    ],
    "DEF": 20,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 20,
    "SPA": 10,
    "SPD": 55,
    "SPE": 80,
    "Species": 349
  },
  {
    "ATK": 60,
    "Abilities": [
      63,
      172,
      56
    ],
    "DEF": 79,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 100,
    "SPD": 125,
    "SPE": 81,
    "Species": 350
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 40,
    "Abilities": [
      26,
      26,
      119
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 20,
    "SPA": 30,
    "SPD": 90,
    "SPE": 25,
    "Species": 355
  },
  {
    "ATK": 70,
    "Abilities": [
      46,
      46,
      119
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 60,
    "SPD": 130,
    "SPE": 25,
    "Species": 356
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 130,
    "Abilities": [
      46,
      105,
      154
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 75,
    "SPD": 60,
    "SPE": 75,
    "Species": 359
  },
  {
    "ATK": 23,
    "Abilities": [
      23,
      23,
      140
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 23,
    "SPD": 48,
    "SPE": 23,
    "Species": 360
  },
  {
    "ATK": 50,
    "Abilities": [
      39,
      115,
      141
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 50,
    "SPD": 50,
    "SPE": 50,
    "Species": 361
  },
  {
    "ATK": 80,
    "Abilities": [
      39,
      115,
      141
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 80,
    "SPD": 80,
    "SPE": 80,
    "Species": 362
  },
  {
    "ATK": 40,
    "Abilities": [
      47,
      115,
      12
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 55,
    "SPD": 50,
    "SPE": 25,
    "Species": 363
  },
  {
    "ATK": 60,
    "Abilities": [
      47,
      115,
      12
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 75,
    "SPD": 70,
    "SPE": 45,
    "Species": 364
  },
  {
    "ATK": 80,
    "Abilities": [
      47,
      115,
      12
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 95,
    "SPD": 90,
    "SPE": 65,
    "Species": 365
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 90,
    "Abilities": [
      33,
      69,
      5
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 100,
    "SPA": 45,
    "SPD": 65,
    "SPE": 55,
    "Species": 369
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 75,
    "Abilities": [
      69,
      69,
      125
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 40,
    "SPD": 30,
    "SPE": 50,
    "Species": 371
  },
  {
    "ATK": 95,
    "Abilities": [
      69,
      69,
      142
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 60,
    "SPD": 50,
    "SPE": 50,
    "Species": 372
  },
  {
    "ATK": 135,
    "Abilities": [
      22,
      22,
      153
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 110,
    "SPD": 80,
    "SPE": 100,
    "Species": 373
  },
  {
    "ATK": 55,
    "Abilities": [
      29,
      29,
      135
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 40,
    "SPA": 35,
    "SPD": 60,
    "SPE": 30,
    "Species": 374
  },
  {
    "ATK": 75,
    "Abilities": [
      29,
      29,
      135
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 60,
    "SPA": 55,
    "SPD": 80,
    "SPE": 50,
    "Species": 375
  },
  {
    "ATK": 135,
    "Abilities": [
      29,
      29,
      135
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 95,
    "SPD": 90,
    "SPE": 70,
    "Species": 376
  },
  {
    "ATK": 100,
    "Abilities": [
      29,
      29,
      5
    ],
    "DEF": 200,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 50,
    "SPD": 100,
    "SPE": 50,
    "Species": 377
  },
  {
    "ATK": 50,
    "Abilities": [
      29,
      29,
      115
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 100,
    "SPD": 200,
    "SPE": 50,
    "Species": 378
  },
  {
    "ATK": 75,
    "Abilities": [
      29,
      29,
      135
    ],
    "DEF": 150,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 75,
    "SPD": 150,
    "SPE": 50,
    "Species": 379
  },
  {
    "ATK": 80,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 80,
    "SPA": 110,
    "SPD": 130,
    "SPE": 110,
    "Species": 380
  },
  {
    "ATK": 90,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 80,
    "SPA": 130,
    "SPD": 110,
    "SPE": 110,
    "Species": 381
  },
  {
    "ATK": 100,
    "Abilities": [
      2,
      2,
      2
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 150,
    "SPD": 140,
    "SPE": 90,
    "Species": 382
  },
  {
    "ATK": 150,
    "Abilities": [
      70,
      70,
      70
    ],
    "DEF": 140,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 100,
    "SPD": 90,
    "SPE": 90,
    "Species": 383
  },
  {
    "ATK": 150,
    "Abilities": [
      76,
      76,
      76
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 972,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 105,
    "SPA": 150,
    "SPD": 90,
    "SPE": 95,
    "Species": 384
  },
  {
    "ATK": 100,
    "Abilities": [
      32,
      32,
      32
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 100,
    "SPD": 100,
    "SPE": 100,
    "Species": 385
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 65,
    "Abilities": [
      79,
      22,
      62
    ],
    "DEF": 34,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 40,
    "SPD": 34,
    "SPE": 45,
    "Species": 403
  },
  {
    "ATK": 85,
    "Abilities": [
      79,
      22,
      62
    ],
    "DEF": 49,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 60,
    "SPD": 49,
    "SPE": 60,
    "Species": 404
  },
  {
    "ATK": 120,
    "Abilities": [
      79,
      22,
      62
    ],
    "DEF": 79,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 95,
    "SPD": 79,
    "SPE": 70,
    "Species": 405
  },
  {
    "ATK": 30,
    "Abilities": [
      30,
      38,
      102
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 50,
    "SPD": 70,
    "SPE": 55,
    "Species": 406
  },
  {
    "ATK": 70,
    "Abilities": [
      30,
      38,
      101
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 125,
    "SPD": 105,
    "SPE": 90,
    "Species": 407
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 30,
    "Abilities": [
      118,
      118,
      55
    ],
    "DEF": 42,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 30,
    "SPA": 30,
    "SPD": 42,
    "SPE": 70,
    "Species": 415
  },
  {
    "ATK": 80,
    "Abilities": [
      46,
      46,
      127
    ],
    "DEF": 102,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 70,
    "SPA": 80,
    "SPD": 102,
    "SPE": 40,
    "Species": 416
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 35,
    "Abilities": [
      34,
      34,
      34
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 62,
    "SPD": 53,
    "SPE": 35,
    "Species": 420
  },
  {
    "ATK": 60,
    "Abilities": [
      122,
      122,
      122
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 982,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 70,
    "SPA": 87,
    "SPD": 78,
    "SPE": 85,
    "Species": 421
  },
  {
    "ATK": 48,
    "Abilities": [
      60,
      114,
      159
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 983,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 76,
    "SPA": 57,
    "SPD": 62,
    "SPE": 34,
    "Species": 422
  },
  {
    "ATK": 83,
    "Abilities": [
      60,
      114,
      159
    ],
    "DEF": 68,
    "FormIndex": 0,
    "FormStatsIndex": 984,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 111,
    "SPA": 92,
    "SPD": 82,
    "SPE": 39,
    "Species": 423
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 50,
    "Abilities": [
      106,
      84,
      138
    ],
    "DEF": 34,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 60,
    "SPD": 44,
    "SPE": 70,
    "Species": 425
  },
  {
    "ATK": 80,
    "Abilities": [
      106,
      84,
      138
    ],
    "DEF": 44,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 150,
    "SPA": 90,
    "SPD": 54,
    "SPE": 80,
    "Species": 426
  },
  {
    "ATK": 66,
    "Abilities": [
      50,
      103,
      7
    ],
    "DEF": 44,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 44,
    "SPD": 56,
    "SPE": 85,
    "Species": 427
  },
  {
    "ATK": 76,
    "Abilities": [
      56,
      103,
      7
    ],
    "DEF": 84,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 54,
    "SPD": 96,
    "SPE": 105,
    "Species": 428
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 63,
    "Abilities": [
      1,
      106,
      51
    ],
    "DEF": 47,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 63,
    "SPA": 41,
    "SPD": 41,
    "SPE": 74,
    "Species": 434
  },
  {
    "ATK": 93,
    "Abilities": [
      1,
      106,
      51
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 103,
    "SPA": 71,
    "SPD": 61,
    "SPE": 84,
    "Species": 435
  },
  {
    "ATK": 24,
    "Abilities": [
      26,
      85,
      134
    ],
    "DEF": 86,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 57,
    "SPA": 24,
    "SPD": 86,
    "SPE": 23,
    "Species": 436
  },
  {
    "ATK": 89,
    "Abilities": [
      26,
      85,
      134
    ],
    "DEF": 116,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 67,
    "SPA": 79,
    "SPD": 116,
    "SPE": 33,
    "Species": 437
  },
  {
    "ATK": 80,
    "Abilities": [
      5,
      69,
      155
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 10,
    "SPD": 45,
    "SPE": 10,
    "Species": 438
  },
  {
    "ATK": 25,
    "Abilities": [
      43,
      111,
      101
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 20,
    "SPA": 70,
    "SPD": 90,
    "SPE": 60,
    "Species": 439
  },
  {
    "ATK": 5,
    "Abilities": [
      30,
      32,
      132
    ],
    "DEF": 5,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 100,
    "SPA": 15,
    "SPD": 65,
    "SPE": 30,
    "Species": 440
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 92,
    "Abilities": [
      46,
      46,
      151
    ],
    "DEF": 108,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 92,
    "SPD": 108,
    "SPE": 35,
    "Species": 442
  },
  {
    "ATK": 70,
    "Abilities": [
      8,
      8,
      24
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 58,
    "SPA": 40,
    "SPD": 45,
    "SPE": 42,
    "Species": 443
  },
  {
    "ATK": 90,
    "Abilities": [
      8,
      8,
      24
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 50,
    "SPD": 55,
    "SPE": 82,
    "Species": 444
  },
  {
    "ATK": 130,
    "Abilities": [
      8,
      8,
      24
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 108,
    "SPA": 80,
    "SPD": 85,
    "SPE": 102,
    "Species": 445
  },
  {
    "ATK": 85,
    "Abilities": [
      53,
      47,
      82
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 135,
    "SPA": 40,
    "SPD": 85,
    "SPE": 5,
    "Species": 446
  },
  {
    "ATK": 70,
    "Abilities": [
      80,
      39,
      158
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 40,
    "SPA": 35,
    "SPD": 40,
    "SPE": 60,
    "Species": 447
  },
  {
    "ATK": 110,
    "Abilities": [
      80,
      39,
      154
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 70,
    "SPA": 115,
    "SPD": 70,
    "SPE": 90,
    "Species": 448
  },
  {
    "ATK": 72,
    "Abilities": [
      45,
      45,
      159
    ],
    "DEF": 78,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 38,
    "SPD": 42,
    "SPE": 32,
    "Species": 449
  },
  {
    "ATK": 112,
    "Abilities": [
      45,
      45,
      159
    ],
    "DEF": 118,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 108,
    "SPA": 68,
    "SPD": 72,
    "SPE": 47,
    "Species": 450
  },
  {
    "ATK": 50,
    "Abilities": [
      4,
      97,
      51
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 30,
    "SPD": 55,
    "SPE": 65,
    "Species": 451
  },
  {
    "ATK": 90,
    "Abilities": [
      4,
      97,
      51
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 60,
    "SPD": 75,
    "SPE": 95,
    "Species": 452
  },
  {
    "ATK": 61,
    "Abilities": [
      107,
      87,
      143
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 48,
    "SPA": 61,
    "SPD": 40,
    "SPE": 50,
    "Species": 453
  },
  {
    "ATK": 106,
    "Abilities": [
      107,
      87,
      143
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 83,
    "SPA": 86,
    "SPD": 65,
    "SPE": 85,
    "Species": 454
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 20,
    "Abilities": [
      33,
      11,
      41
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 60,
    "SPD": 120,
    "SPE": 50,
    "Species": 458
  },
  {
    "ATK": 62,
    "Abilities": [
      117,
      117,
      43
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 62,
    "SPD": 60,
    "SPE": 40,
    "Species": 459
  },
  {
    "ATK": 92,
    "Abilities": [
      117,
      117,
      43
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 92,
    "SPD": 85,
    "SPE": 60,
    "Species": 460
  },
  {
    "ATK": 120,
    "Abilities": [
      46,
      46,
      124
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 45,
    "SPD": 85,
    "SPE": 125,
    "Species": 461
  },
  {
    "ATK": 70,
    "Abilities": [
      42,
      5,
      148
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 70,
    "SPA": 130,
    "SPD": 90,
    "SPE": 60,
    "Species": 462
  },
  {
    "ATK": 85,
    "Abilities": [
      20,
      12,
      13
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 80,
    "SPD": 95,
    "SPE": 50,
    "Species": 463
  },
  {
    "ATK": 140,
    "Abilities": [
      31,
      116,
      120
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 115,
    "SPA": 55,
    "SPD": 55,
    "SPE": 40,
    "Species": 464
  },
  {
    "ATK": 100,
    "Abilities": [
      34,
      102,
      144
    ],
    "DEF": 125,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 110,
    "SPD": 50,
    "SPE": 50,
    "Species": 465
  },
  {
    "ATK": 123,
    "Abilities": [
      78,
      78,
      72
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 75,
    "SPA": 95,
    "SPD": 85,
    "SPE": 95,
    "Species": 466
  },
  {
    "ATK": 95,
    "Abilities": [
      49,
      49,
      72
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 75,
    "SPA": 125,
    "SPD": 95,
    "SPE": 83,
    "Species": 467
  },
  {
    "ATK": 50,
    "Abilities": [
      55,
      32,
      105
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 85,
    "SPA": 120,
    "SPD": 115,
    "SPE": 80,
    "Species": 468
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 110,
    "Abilities": [
      102,
      102,
      34
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 60,
    "SPD": 65,
    "SPE": 95,
    "Species": 470
  },
  {
    "ATK": 60,
    "Abilities": [
      81,
      81,
      115
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 130,
    "SPD": 95,
    "SPE": 65,
    "Species": 471
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 130,
    "Abilities": [
      12,
      81,
      47
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 70,
    "SPD": 60,
    "SPE": 80,
    "Species": 473
  },
  {
    "ATK": 80,
    "Abilities": [
      91,
      88,
      148
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 85,
    "SPA": 135,
    "SPD": 75,
    "SPE": 90,
    "Species": 474
  },
  {
    "ATK": 125,
    "Abilities": [
      80,
      80,
      154
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 68,
    "SPA": 65,
    "SPD": 115,
    "SPE": 80,
    "Species": 475
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 100,
    "Abilities": [
      46,
      46,
      119
    ],
    "DEF": 135,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 65,
    "SPD": 135,
    "SPE": 45,
    "Species": 477
  },
  {
    "ATK": 80,
    "Abilities": [
      81,
      81,
      130
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 70,
    "SPA": 80,
    "SPD": 70,
    "SPE": 110,
    "Species": 478
  },
  {
    "ATK": 50,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 77,
    "FormIndex": 0,
    "FormStatsIndex": 985,
    "FormeCount": 6,
    "Gender": 255,
    "HP": 50,
    "SPA": 95,
    "SPD": 77,
    "SPE": 91,
    "Species": 479
  },
  {
    "ATK": 75,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 75,
    "SPA": 75,
    "SPD": 130,
    "SPE": 95,
    "Species": 480
  },
  {
    "ATK": 105,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 105,
    "SPD": 105,
    "SPE": 80,
    "Species": 481
  },
  {
    "ATK": 125,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 75,
    "SPA": 125,
    "SPD": 70,
    "SPE": 115,
    "Species": 482
  },
  {
    "ATK": 120,
    "Abilities": [
      46,
      46,
      140
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 150,
    "SPD": 100,
    "SPE": 90,
    "Species": 483
  },
  {
    "ATK": 120,
    "Abilities": [
      46,
      46,
      140
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 150,
    "SPD": 120,
    "SPE": 100,
    "Species": 484
  },
  {
    "ATK": 90,
    "Abilities": [
      18,
      18,
      49
    ],
    "DEF": 106,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 91,
    "SPA": 130,
    "SPD": 106,
    "SPE": 77,
    "Species": 485
  },
  {
    "ATK": 160,
    "Abilities": [
      112,
      112,
      112
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 110,
    "SPA": 80,
    "SPD": 110,
    "SPE": 100,
    "Species": 486
  },
  {
    "ATK": 100,
    "Abilities": [
      46,
      46,
      140
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 990,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 150,
    "SPA": 100,
    "SPD": 120,
    "SPE": 90,
    "Species": 487
  },
  {
    "ATK": 70,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 120,
    "SPA": 75,
    "SPD": 130,
    "SPE": 85,
    "Species": 488
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 100,
    "Abilities": [
      162,
      162,
      162
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 100,
    "SPD": 100,
    "SPE": 100,
    "Species": 494
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 60,
    "Abilities": [
      72,
      53,
      50
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 25,
    "SPD": 45,
    "SPE": 55,
    "Species": 506
  },
  {
    "ATK": 80,
    "Abilities": [
      22,
      146,
      113
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 35,
    "SPD": 65,
    "SPE": 60,
    "Species": 507
  },
  {
    "ATK": 110,
    "Abilities": [
      22,
      146,
      113
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 45,
    "SPD": 90,
    "SPE": 80,
    "Species": 508
  },
  {
    "ATK": 50,
    "Abilities": [
      7,
      84,
      158
    ],
    "DEF": 37,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 41,
    "SPA": 50,
    "SPD": 37,
    "SPE": 66,
    "Species": 509
  },
  {
    "ATK": 88,
    "Abilities": [
      7,
      84,
      158
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 64,
    "SPA": 88,
    "SPD": 50,
    "SPE": 106,
    "Species": 510
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 25,
    "Abilities": [
      108,
      28,
      140
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 76,
    "SPA": 67,
    "SPD": 55,
    "SPE": 24,
    "Species": 517
  },
  {
    "ATK": 55,
    "Abilities": [
      108,
      28,
      140
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 116,
    "SPA": 107,
    "SPD": 95,
    "SPE": 29,
    "Species": 518
  },
  {
    "ATK": 55,
    "Abilities": [
      145,
      105,
      79
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 36,
    "SPD": 30,
    "SPE": 43,
    "Species": 519
  },
  {
    "ATK": 77,
    "Abilities": [
      145,
      105,
      79
    ],
    "DEF": 62,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 62,
    "SPA": 50,
    "SPD": 42,
    "SPE": 65,
    "Species": 520
  },
  {
    "ATK": 115,
    "Abilities": [
      145,
      105,
      79
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 65,
    "SPD": 55,
    "SPE": 93,
    "Species": 521
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 75,
    "Abilities": [
      5,
      133,
      159
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 25,
    "SPD": 25,
    "SPE": 15,
    "Species": 524
  },
  {
    "ATK": 105,
    "Abilities": [
      5,
      133,
      159
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 50,
    "SPD": 40,
    "SPE": 20,
    "Species": 525
  },
  {
    "ATK": 135,
    "Abilities": [
      5,
      45,
      159
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 60,
    "SPD": 80,
    "SPE": 25,
    "Species": 526
  },
  {
    "ATK": 45,
    "Abilities": [
      109,
      103,
      86
    ],
    "DEF": 43,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 55,
    "SPD": 43,
    "SPE": 72,
    "Species": 527
  },
  {
    "ATK": 57,
    "Abilities": [
      109,
      103,
      86
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 67,
    "SPA": 77,
    "SPD": 55,
    "SPE": 114,
    "Species": 528
  },
  {
    "ATK": 85,
    "Abilities": [
      146,
      159,
      104
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 30,
    "SPD": 45,
    "SPE": 68,
    "Species": 529
  },
  {
    "ATK": 135,
    "Abilities": [
      146,
      159,
      104
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 50,
    "SPD": 65,
    "SPE": 88,
    "Species": 530
  },
  {
    "ATK": 60,
    "Abilities": [
      131,
      144,
      103
    ],
    "DEF": 86,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 103,
    "SPA": 60,
    "SPD": 86,
    "SPE": 50,
    "Species": 531
  },
  {
    "ATK": 80,
    "Abilities": [
      62,
      125,
      89
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 75,
    "SPA": 25,
    "SPD": 35,
    "SPE": 35,
    "Species": 532
  },
  {
    "ATK": 105,
    "Abilities": [
      62,
      125,
      89
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 85,
    "SPA": 40,
    "SPD": 50,
    "SPE": 40,
    "Species": 533
  },
  {
    "ATK": 140,
    "Abilities": [
      62,
      125,
      89
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 63,
    "HP": 105,
    "SPA": 55,
    "SPD": 65,
    "SPE": 45,
    "Species": 534
  },
  {
    "ATK": 50,
    "Abilities": [
      33,
      93,
      11
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 50,
    "SPD": 40,
    "SPE": 64,
    "Species": 535
  },
  {
    "ATK": 65,
    "Abilities": [
      33,
      93,
      11
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 65,
    "SPD": 55,
    "SPE": 69,
    "Species": 536
  },
  {
    "ATK": 95,
    "Abilities": [
      33,
      143,
      11
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 105,
    "SPA": 85,
    "SPD": 75,
    "SPE": 74,
    "Species": 537
  },
  {
    "ATK": 100,
    "Abilities": [
      62,
      39,
      104
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 120,
    "SPA": 30,
    "SPD": 85,
    "SPE": 45,
    "Species": 538
  },
  {
    "ATK": 125,
    "Abilities": [
      5,
      39,
      104
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 75,
    "SPA": 30,
    "SPD": 75,
    "SPE": 85,
    "Species": 539
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 45,
    "Abilities": [
      38,
      68,
      3
    ],
    "DEF": 59,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 30,
    "SPD": 39,
    "SPE": 57,
    "Species": 543
  },
  {
    "ATK": 55,
    "Abilities": [
      38,
      68,
      3
    ],
    "DEF": 99,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 40,
    "SPD": 79,
    "SPE": 47,
    "Species": 544
  },
  {
    "ATK": 100,
    "Abilities": [
      38,
      68,
      3
    ],
    "DEF": 89,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 55,
    "SPD": 69,
    "SPE": 112,
    "Species": 545
  },
  {
    "ATK": 27,
    "Abilities": [
      158,
      151,
      34
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 37,
    "SPD": 50,
    "SPE": 66,
    "Species": 546
  },
  {
    "ATK": 67,
    "Abilities": [
      158,
      151,
      34
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 77,
    "SPD": 75,
    "SPE": 116,
    "Species": 547
  },
  {
    "ATK": 35,
    "Abilities": [
      34,
      20,
      102
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 45,
    "SPA": 70,
    "SPD": 50,
    "SPE": 30,
    "Species": 548
  },
  {
    "ATK": 60,
    "Abilities": [
      34,
      20,
      102
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 70,
    "SPA": 110,
    "SPD": 75,
    "SPE": 90,
    "Species": 549
  },
  {
    "ATK": 92,
    "Abilities": [
      120,
      91,
      104
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1009,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 70,
    "SPA": 80,
    "SPD": 55,
    "SPE": 98,
    "Species": 550
  },
  {
    "ATK": 72,
    "Abilities": [
      22,
      153,
      83
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 35,
    "SPD": 35,
    "SPE": 65,
    "Species": 551
  },
  {
    "ATK": 82,
    "Abilities": [
      22,
      153,
      83
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 45,
    "SPD": 45,
    "SPE": 74,
    "Species": 552
  },
  {
    "ATK": 117,
    "Abilities": [
      22,
      153,
      83
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 65,
    "SPD": 70,
    "SPE": 92,
    "Species": 553
  },
  {
    "ATK": 90,
    "Abilities": [
      55,
      55,
      39
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 1010,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 70,
    "SPA": 15,
    "SPD": 45,
    "SPE": 50,
    "Species": 554
  },
  {
    "ATK": 140,
    "Abilities": [
      125,
      125,
      161
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 1011,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 105,
    "SPA": 30,
    "SPD": 55,
    "SPE": 95,
    "Species": 555
  },
  {
    "ATK": 86,
    "Abilities": [
      11,
      34,
      114
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 106,
    "SPD": 67,
    "SPE": 60,
    "Species": 556
  },
  {
    "ATK": 65,
    "Abilities": [
      5,
      75,
      133
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 35,
    "SPD": 35,
    "SPE": 55,
    "Species": 557
  },
  {
    "ATK": 105,
    "Abilities": [
      5,
      75,
      133
    ],
    "DEF": 125,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 65,
    "SPD": 75,
    "SPE": 45,
    "Species": 558
  },
  {
    "ATK": 75,
    "Abilities": [
      61,
      153,
      22
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 35,
    "SPD": 70,
    "SPE": 48,
    "Species": 559
  },
  {
    "ATK": 90,
    "Abilities": [
      61,
      153,
      22
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 45,
    "SPD": 115,
    "SPE": 58,
    "Species": 560
  },
  {
    "ATK": 58,
    "Abilities": [
      147,
      98,
      110
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 72,
    "SPA": 103,
    "SPD": 80,
    "SPE": 97,
    "Species": 561
  },
  {
    "ATK": 30,
    "Abilities": [
      152,
      152,
      152
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 1014,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 38,
    "SPA": 55,
    "SPD": 65,
    "SPE": 30,
    "Species": 562
  },
  {
    "ATK": 50,
    "Abilities": [
      152,
      152,
      152
    ],
    "DEF": 145,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 58,
    "SPA": 95,
    "SPD": 105,
    "SPE": 30,
    "Species": 563
  },
  {
    "ATK": 78,
    "Abilities": [
      116,
      5,
      33
    ],
    "DEF": 103,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 54,
    "SPA": 53,
    "SPD": 45,
    "SPE": 22,
    "Species": 564
  },
  {
    "ATK": 108,
    "Abilities": [
      116,
      5,
      33
    ],
    "DEF": 133,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 74,
    "SPA": 83,
    "SPD": 65,
    "SPE": 32,
    "Species": 565
  },
  {
    "ATK": 112,
    "Abilities": [
      129,
      129,
      129
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 55,
    "SPA": 74,
    "SPD": 45,
    "SPE": 70,
    "Species": 566
  },
  {
    "ATK": 140,
    "Abilities": [
      129,
      129,
      129
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 75,
    "SPA": 112,
    "SPD": 65,
    "SPE": 110,
    "Species": 567
  },
  {
    "ATK": 50,
    "Abilities": [
      1,
      60,
      106
    ],
    "DEF": 62,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 40,
    "SPD": 62,
    "SPE": 65,
    "Species": 568
  },
  {
    "ATK": 95,
    "Abilities": [
      1,
      133,
      106
    ],
    "DEF": 82,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 60,
    "SPD": 82,
    "SPE": 75,
    "Species": 569
  },
  {
    "ATK": 65,
    "Abilities": [
      149,
      149,
      149
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 40,
    "SPA": 80,
    "SPD": 40,
    "SPE": 65,
    "Species": 570
  },
  {
    "ATK": 105,
    "Abilities": [
      149,
      149,
      149
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 60,
    "SPA": 120,
    "SPD": 60,
    "SPE": 105,
    "Species": 571
  },
  {
    "ATK": 50,
    "Abilities": [
      56,
      101,
      92
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 55,
    "SPA": 40,
    "SPD": 40,
    "SPE": 75,
    "Species": 572
  },
  {
    "ATK": 95,
    "Abilities": [
      56,
      101,
      92
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 75,
    "SPA": 65,
    "SPD": 60,
    "SPE": 115,
    "Species": 573
  },
  {
    "ATK": 30,
    "Abilities": [
      119,
      172,
      23
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 45,
    "SPA": 55,
    "SPD": 65,
    "SPE": 45,
    "Species": 574
  },
  {
    "ATK": 45,
    "Abilities": [
      119,
      172,
      23
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 60,
    "SPA": 75,
    "SPD": 85,
    "SPE": 55,
    "Species": 575
  },
  {
    "ATK": 55,
    "Abilities": [
      119,
      172,
      23
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 70,
    "SPA": 95,
    "SPD": 110,
    "SPE": 65,
    "Species": 576
  },
  {
    "ATK": 30,
    "Abilities": [
      142,
      98,
      144
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 105,
    "SPD": 50,
    "SPE": 20,
    "Species": 577
  },
  {
    "ATK": 40,
    "Abilities": [
      142,
      98,
      144
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 125,
    "SPD": 60,
    "SPE": 30,
    "Species": 578
  },
  {
    "ATK": 65,
    "Abilities": [
      142,
      98,
      144
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 125,
    "SPD": 85,
    "SPE": 30,
    "Species": 579
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 50,
    "Abilities": [
      115,
      81,
      133
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 36,
    "SPA": 65,
    "SPD": 60,
    "SPE": 44,
    "Species": 582
  },
  {
    "ATK": 65,
    "Abilities": [
      115,
      81,
      133
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 51,
    "SPA": 80,
    "SPD": 75,
    "SPE": 59,
    "Species": 583
  },
  {
    "ATK": 95,
    "Abilities": [
      115,
      117,
      133
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 71,
    "SPA": 110,
    "SPD": 95,
    "SPE": 79,
    "Species": 584
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 75,
    "Abilities": [
      9,
      9,
      78
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 75,
    "SPD": 60,
    "SPE": 103,
    "Species": 587
  },
  {
    "ATK": 75,
    "Abilities": [
      68,
      61,
      99
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 40,
    "SPD": 45,
    "SPE": 60,
    "Species": 588
  },
  {
    "ATK": 135,
    "Abilities": [
      68,
      75,
      142
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 60,
    "SPD": 105,
    "SPE": 20,
    "Species": 589
  },
  {
    "ATK": 55,
    "Abilities": [
      27,
      27,
      144
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 69,
    "SPA": 55,
    "SPD": 55,
    "SPE": 15,
    "Species": 590
  },
  {
    "ATK": 85,
    "Abilities": [
      27,
      27,
      144
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 114,
    "SPA": 85,
    "SPD": 80,
    "SPE": 30,
    "Species": 591
  },
  {
    "ATK": 40,
    "Abilities": [
      11,
      130,
      6
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 65,
    "SPD": 85,
    "SPE": 40,
    "Species": 592
  },
  {
    "ATK": 60,
    "Abilities": [
      11,
      130,
      6
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 85,
    "SPD": 105,
    "SPE": 60,
    "Species": 593
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 47,
    "Abilities": [
      14,
      127,
      68
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 57,
    "SPD": 50,
    "SPE": 65,
    "Species": 595
  },
  {
    "ATK": 77,
    "Abilities": [
      14,
      127,
      68
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 97,
    "SPD": 60,
    "SPE": 108,
    "Species": 596
  },
  {
    "ATK": 50,
    "Abilities": [
      160,
      160,
      160
    ],
    "DEF": 91,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 44,
    "SPA": 24,
    "SPD": 86,
    "SPE": 10,
    "Species": 597
  },
  {
    "ATK": 94,
    "Abilities": [
      160,
      160,
      107
    ],
    "DEF": 131,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 74,
    "SPA": 54,
    "SPD": 116,
    "SPE": 20,
    "Species": 598
  },
  {
    "ATK": 55,
    "Abilities": [
      57,
      58,
      29
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 40,
    "SPA": 45,
    "SPD": 60,
    "SPE": 30,
    "Species": 599
  },
  {
    "ATK": 80,
    "Abilities": [
      57,
      58,
      29
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 60,
    "SPA": 70,
    "SPD": 85,
    "SPE": 50,
    "Species": 600
  },
  {
    "ATK": 100,
    "Abilities": [
      57,
      58,
      29
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 60,
    "SPA": 70,
    "SPD": 85,
    "SPE": 90,
    "Species": 601
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      140,
      28,
      148
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 85,
    "SPD": 55,
    "SPE": 30,
    "Species": 605
  },
  {
    "ATK": 75,
    "Abilities": [
      140,
      28,
      148
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 125,
    "SPD": 95,
    "SPE": 40,
    "Species": 606
  },
  {
    "ATK": 30,
    "Abilities": [
      18,
      49,
      151
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 65,
    "SPD": 55,
    "SPE": 20,
    "Species": 607
  },
  {
    "ATK": 40,
    "Abilities": [
      18,
      49,
      151
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 95,
    "SPD": 60,
    "SPE": 55,
    "Species": 608
  },
  {
    "ATK": 55,
    "Abilities": [
      18,
      49,
      151
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 145,
    "SPD": 90,
    "SPE": 80,
    "Species": 609
  },
  {
    "ATK": 87,
    "Abilities": [
      79,
      104,
      127
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 46,
    "SPA": 30,
    "SPD": 40,
    "SPE": 57,
    "Species": 610
  },
  {
    "ATK": 117,
    "Abilities": [
      79,
      104,
      127
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 66,
    "SPA": 40,
    "SPD": 50,
    "SPE": 67,
    "Species": 611
  },
  {
    "ATK": 147,
    "Abilities": [
      79,
      104,
      127
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 76,
    "SPA": 60,
    "SPD": 70,
    "SPE": 97,
    "Species": 612
  },
  {
    "ATK": 70,
    "Abilities": [
      81,
      202,
      155
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 60,
    "SPD": 40,
    "SPE": 40,
    "Species": 613
  },
  {
    "ATK": 130,
    "Abilities": [
      81,
      202,
      33
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 70,
    "SPD": 80,
    "SPE": 50,
    "Species": 614
  },
  {
    "ATK": 50,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 95,
    "SPD": 135,
    "SPE": 105,
    "Species": 615
  },
  {
    "ATK": 40,
    "Abilities": [
      93,
      75,
      142
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 40,
    "SPD": 65,
    "SPE": 25,
    "Species": 616
  },
  {
    "ATK": 70,
    "Abilities": [
      93,
      60,
      84
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 100,
    "SPD": 60,
    "SPE": 145,
    "Species": 617
  },
  {
    "ATK": 66,
    "Abilities": [
      9,
      7,
      8
    ],
    "DEF": 84,
    "FormIndex": 0,
    "FormStatsIndex": 1021,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 109,
    "SPA": 81,
    "SPD": 99,
    "SPE": 32,
    "Species": 618
  },
  {
    "ATK": 85,
    "Abilities": [
      39,
      144,
      120
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 55,
    "SPD": 50,
    "SPE": 65,
    "Species": 619
  },
  {
    "ATK": 125,
    "Abilities": [
      39,
      144,
      120
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 95,
    "SPD": 60,
    "SPE": 105,
    "Species": 620
  },
  {
    "ATK": 120,
    "Abilities": [
      24,
      125,
      104
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 77,
    "SPA": 60,
    "SPD": 90,
    "SPE": 48,
    "Species": 621
  },
  {
    "ATK": 74,
    "Abilities": [
      89,
      103,
      99
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 59,
    "SPA": 35,
    "SPD": 50,
    "SPE": 35,
    "Species": 622
  },
  {
    "ATK": 124,
    "Abilities": [
      89,
      103,
      99
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 89,
    "SPA": 55,
    "SPD": 80,
    "SPE": 55,
    "Species": 623
  },
  {
    "ATK": 85,
    "Abilities": [
      128,
      39,
      46
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 40,
    "SPD": 40,
    "SPE": 60,
    "Species": 624
  },
  {
    "ATK": 125,
    "Abilities": [
      128,
      39,
      46
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 60,
    "SPD": 70,
    "SPE": 70,
    "Species": 625
  },
  {
    "ATK": 110,
    "Abilities": [
      120,
      157,
      43
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 40,
    "SPD": 95,
    "SPE": 55,
    "Species": 626
  },
  {
    "ATK": 83,
    "Abilities": [
      51,
      125,
      55
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 70,
    "SPA": 37,
    "SPD": 50,
    "SPE": 60,
    "Species": 627
  },
  {
    "ATK": 123,
    "Abilities": [
      51,
      125,
      128
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 100,
    "SPA": 57,
    "SPD": 75,
    "SPE": 80,
    "Species": 628
  },
  {
    "ATK": 55,
    "Abilities": [
      145,
      142,
      133
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 70,
    "SPA": 45,
    "SPD": 65,
    "SPE": 60,
    "Species": 629
  },
  {
    "ATK": 65,
    "Abilities": [
      145,
      142,
      133
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 110,
    "SPA": 55,
    "SPD": 95,
    "SPE": 80,
    "Species": 630
  },
  {
    "ATK": 97,
    "Abilities": [
      82,
      18,
      73
    ],
    "DEF": 66,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 105,
    "SPD": 66,
    "SPE": 65,
    "Species": 631
  },
  {
    "ATK": 109,
    "Abilities": [
      68,
      55,
      54
    ],
    "DEF": 112,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 58,
    "SPA": 48,
    "SPD": 48,
    "SPE": 109,
    "Species": 632
  },
  {
    "ATK": 65,
    "Abilities": [
      55,
      55,
      55
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 52,
    "SPA": 45,
    "SPD": 50,
    "SPE": 38,
    "Species": 633
  },
  {
    "ATK": 85,
    "Abilities": [
      55,
      55,
      55
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 72,
    "SPA": 65,
    "SPD": 70,
    "SPE": 58,
    "Species": 634
  },
  {
    "ATK": 105,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 92,
    "SPA": 125,
    "SPD": 90,
    "SPE": 98,
    "Species": 635
  },
  {
    "ATK": 85,
    "Abilities": [
      49,
      49,
      68
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 50,
    "SPD": 55,
    "SPE": 60,
    "Species": 636
  },
  {
    "ATK": 60,
    "Abilities": [
      49,
      49,
      68
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 135,
    "SPD": 105,
    "SPE": 100,
    "Species": 637
  },
  {
    "ATK": 90,
    "Abilities": [
      154,
      154,
      154
    ],
    "DEF": 129,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 91,
    "SPA": 90,
    "SPD": 72,
    "SPE": 108,
    "Species": 638
  },
  {
    "ATK": 129,
    "Abilities": [
      154,
      154,
      154
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 91,
    "SPA": 72,
    "SPD": 90,
    "SPE": 108,
    "Species": 639
  },
  {
    "ATK": 90,
    "Abilities": [
      154,
      154,
      154
    ],
    "DEF": 72,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 91,
    "SPA": 90,
    "SPD": 129,
    "SPE": 108,
    "Species": 640
  },
  {
    "ATK": 115,
    "Abilities": [
      158,
      158,
      128
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1022,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 79,
    "SPA": 125,
    "SPD": 80,
    "SPE": 111,
    "Species": 641
  },
  {
    "ATK": 115,
    "Abilities": [
      158,
      158,
      128
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1023,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 79,
    "SPA": 125,
    "SPD": 80,
    "SPE": 111,
    "Species": 642
  },
  {
    "ATK": 120,
    "Abilities": [
      163,
      163,
      163
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 150,
    "SPD": 120,
    "SPE": 90,
    "Species": 643
  },
  {
    "ATK": 150,
    "Abilities": [
      164,
      164,
      164
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 120,
    "SPD": 100,
    "SPE": 90,
    "Species": 644
  },
  {
    "ATK": 125,
    "Abilities": [
      159,
      159,
      125
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 1024,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 89,
    "SPA": 115,
    "SPD": 80,
    "SPE": 101,
    "Species": 645
  },
  {
    "ATK": 130,
    "Abilities": [
      46,
      46,
      46
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 1025,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 125,
    "SPA": 130,
    "SPD": 90,
    "SPE": 95,
    "Species": 646
  },
  {
    "ATK": 72,
    "Abilities": [
      154,
      154,
      154
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 1027,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 91,
    "SPA": 129,
    "SPD": 90,
    "SPE": 108,
    "Species": 647
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 120,
    "Abilities": [
      88,
      88,
      88
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1029,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 71,
    "SPA": 120,
    "SPD": 95,
    "SPE": 99,
    "Species": 649
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 36,
    "Abilities": [
      53,
      167,
      37
    ],
    "DEF": 38,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 38,
    "SPA": 32,
    "SPD": 36,
    "SPE": 57,
    "Species": 711
  },
  {
    "ATK": 56,
    "Abilities": [
      53,
      167,
      37
    ],
    "DEF": 77,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 50,
    "SPD": 77,
    "SPE": 78,
    "Species": 712
  },
  {
    "ATK": 50,
    "Abilities": [
      145,
      145,
      177
    ],
    "DEF": 43,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 40,
    "SPD": 38,
    "SPE": 62,
    "Species": 753
  },
  {
    "ATK": 73,
    "Abilities": [
      49,
      49,
      177
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 62,
    "SPA": 56,
    "SPD": 52,
    "SPE": 84,
    "Species": 754
  },
  {
    "ATK": 81,
    "Abilities": [
      49,
      49,
      177
    ],
    "DEF": 71,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 78,
    "SPA": 74,
    "SPD": 69,
    "SPE": 126,
    "Species": 755
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 82,
    "Abilities": [
      89,
      104,
      113
    ],
    "DEF": 62,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 67,
    "SPA": 46,
    "SPD": 48,
    "SPE": 43,
    "Species": 752
  },
  {
    "ATK": 124,
    "Abilities": [
      89,
      104,
      113
    ],
    "DEF": 78,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 69,
    "SPD": 71,
    "SPE": 58,
    "Species": 730
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 48,
    "Abilities": [
      51,
      151,
      20
    ],
    "DEF": 54,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 62,
    "SPA": 63,
    "SPD": 60,
    "SPE": 68,
    "Species": 733
  },
  {
    "ATK": 48,
    "Abilities": [
      51,
      151,
      158
    ],
    "DEF": 76,
    "FormIndex": 0,
    "FormStatsIndex": 1114,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 74,
    "SPA": 83,
    "SPD": 81,
    "SPE": 104,
    "Species": 734
  },
  {
    "ATK": 80,
    "Abilities": [
      99,
      99,
      99
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 35,
    "SPD": 37,
    "SPE": 28,
    "Species": 744
  },
  {
    "ATK": 110,
    "Abilities": [
      99,
      99,
      99
    ],
    "DEF": 150,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 59,
    "SPA": 45,
    "SPD": 49,
    "SPE": 35,
    "Species": 745
  },
  {
    "ATK": 50,
    "Abilities": [
      176,
      176,
      176
    ],
    "DEF": 140,
    "FormIndex": 0,
    "FormStatsIndex": 1115,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 60,
    "SPA": 50,
    "SPD": 140,
    "SPE": 60,
    "Species": 746
  },
  {
    "ATK": 52,
    "Abilities": [
      131,
      131,
      165
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 78,
    "SPA": 63,
    "SPD": 65,
    "SPE": 23,
    "Species": 758
  },
  {
    "ATK": 72,
    "Abilities": [
      131,
      131,
      165
    ],
    "DEF": 72,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 101,
    "SPA": 99,
    "SPD": 89,
    "SPE": 29,
    "Species": 759
  },
  {
    "ATK": 48,
    "Abilities": [
      175,
      175,
      84
    ],
    "DEF": 66,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 62,
    "SPA": 59,
    "SPD": 57,
    "SPE": 49,
    "Species": 742
  },
  {
    "ATK": 80,
    "Abilities": [
      175,
      175,
      84
    ],
    "DEF": 86,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 82,
    "SPA": 85,
    "SPD": 75,
    "SPE": 72,
    "Species": 743
  },
  {
    "ATK": 54,
    "Abilities": [
      126,
      21,
      151
    ],
    "DEF": 53,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 53,
    "SPA": 37,
    "SPD": 46,
    "SPE": 45,
    "Species": 726
  },
  {
    "ATK": 92,
    "Abilities": [
      126,
      21,
      151
    ],
    "DEF": 88,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 86,
    "SPA": 68,
    "SPD": 75,
    "SPE": 73,
    "Species": 727
  },
  {
    "ATK": 52,
    "Abilities": [
      181,
      97,
      124
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 42,
    "SPA": 39,
    "SPD": 56,
    "SPE": 50,
    "Species": 747
  },
  {
    "ATK": 105,
    "Abilities": [
      181,
      97,
      124
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 72,
    "SPA": 54,
    "SPD": 86,
    "SPE": 68,
    "Species": 748
  },
  {
    "ATK": 60,
    "Abilities": [
      38,
      143,
      91
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 60,
    "SPD": 60,
    "SPE": 30,
    "Species": 709
  },
  {
    "ATK": 75,
    "Abilities": [
      38,
      143,
      91
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 97,
    "SPD": 123,
    "SPE": 44,
    "Species": 710
  },
  {
    "ATK": 53,
    "Abilities": [
      178,
      178,
      178
    ],
    "DEF": 62,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 58,
    "SPD": 63,
    "SPE": 44,
    "Species": 756
  },
  {
    "ATK": 73,
    "Abilities": [
      178,
      178,
      178
    ],
    "DEF": 88,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 71,
    "SPA": 120,
    "SPD": 89,
    "SPE": 59,
    "Species": 757
  },
  {
    "ATK": 38,
    "Abilities": [
      87,
      8,
      94
    ],
    "DEF": 33,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 44,
    "SPA": 61,
    "SPD": 43,
    "SPE": 70,
    "Species": 731
  },
  {
    "ATK": 55,
    "Abilities": [
      87,
      8,
      94
    ],
    "DEF": 52,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 62,
    "SPA": 109,
    "SPD": 94,
    "SPE": 109,
    "Species": 732
  },
  {
    "ATK": 89,
    "Abilities": [
      173,
      173,
      5
    ],
    "DEF": 77,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 58,
    "SPA": 45,
    "SPD": 45,
    "SPE": 48,
    "Species": 737
  },
  {
    "ATK": 121,
    "Abilities": [
      173,
      173,
      69
    ],
    "DEF": 119,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 82,
    "SPA": 69,
    "SPD": 59,
    "SPE": 71,
    "Species": 738
  },
  {
    "ATK": 59,
    "Abilities": [
      174,
      174,
      117
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 77,
    "SPA": 67,
    "SPD": 63,
    "SPE": 46,
    "Species": 739
  },
  {
    "ATK": 77,
    "Abilities": [
      174,
      174,
      117
    ],
    "DEF": 72,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 123,
    "SPA": 99,
    "SPD": 92,
    "SPE": 58,
    "Species": 740
  },
  {
    "ATK": 65,
    "Abilities": [
      56,
      56,
      182
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 95,
    "SPA": 110,
    "SPD": 130,
    "SPE": 60,
    "Species": 767
  },
  {
    "ATK": 92,
    "Abilities": [
      7,
      84,
      104
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 78,
    "SPA": 74,
    "SPD": 63,
    "SPE": 118,
    "Species": 761
  },
  {
    "ATK": 58,
    "Abilities": [
      167,
      53,
      57
    ],
    "DEF": 57,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 67,
    "SPA": 81,
    "SPD": 67,
    "SPE": 101,
    "Species": 741
  },
  {
    "ATK": 50,
    "Abilities": [
      29,
      29,
      5
    ],
    "DEF": 150,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 50,
    "SPA": 50,
    "SPD": 150,
    "SPE": 50,
    "Species": 766
  },
  {
    "ATK": 50,
    "Abilities": [
      157,
      93,
      183
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 55,
    "SPD": 75,
    "SPE": 40,
    "Species": 763
  },
  {
    "ATK": 75,
    "Abilities": [
      157,
      93,
      183
    ],
    "DEF": 53,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 83,
    "SPD": 113,
    "SPE": 60,
    "Species": 764
  },
  {
    "ATK": 100,
    "Abilities": [
      157,
      93,
      183
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 110,
    "SPD": 150,
    "SPE": 80,
    "Species": 765
  },
  {
    "ATK": 80,
    "Abilities": [
      158,
      158,
      170
    ],
    "DEF": 91,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 57,
    "SPA": 80,
    "SPD": 87,
    "SPE": 75,
    "Species": 760
  },
  {
    "ATK": 70,
    "Abilities": [
      30,
      119,
      139
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 43,
    "SPA": 50,
    "SPD": 60,
    "SPE": 38,
    "Species": 702
  },
  {
    "ATK": 110,
    "Abilities": [
      30,
      119,
      139
    ],
    "DEF": 76,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 65,
    "SPD": 82,
    "SPE": 56,
    "Species": 703
  },
  {
    "ATK": 66,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1116,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 49,
    "SPA": 44,
    "SPD": 55,
    "SPE": 51,
    "Species": 735
  },
  {
    "ATK": 90,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 122,
    "FormIndex": 0,
    "FormStatsIndex": 1119,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 65,
    "SPA": 58,
    "SPD": 75,
    "SPE": 84,
    "Species": 736
  },
  {
    "ATK": 69,
    "Abilities": [
      20,
      115,
      5
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 32,
    "SPD": 35,
    "SPE": 28,
    "Species": 749
  },
  {
    "ATK": 117,
    "Abilities": [
      20,
      115,
      5
    ],
    "DEF": 184,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 95,
    "SPA": 44,
    "SPD": 46,
    "SPE": 28,
    "Species": 751
  },
  {
    "ATK": 30,
    "Abilities": [
      119,
      151,
      140
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 45,
    "SPD": 40,
    "SPE": 55,
    "Species": 716
  },
  {
    "ATK": 70,
    "Abilities": [
      119,
      151,
      140
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 97,
    "SPD": 80,
    "SPE": 123,
    "Species": 762
  },
  {
    "ATK": 131,
    "Abilities": [
      187,
      187,
      187
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1122,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 126,
    "SPA": 131,
    "SPD": 98,
    "SPE": 99,
    "Species": 768
  },
  {
    "ATK": 131,
    "Abilities": [
      186,
      186,
      186
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 126,
    "SPA": 131,
    "SPD": 98,
    "SPE": 99,
    "Species": 769
  },
  {
    "ATK": 100,
    "Abilities": [
      188,
      188,
      188
    ],
    "DEF": 121,
    "FormIndex": 0,
    "FormStatsIndex": 1123,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 108,
    "SPA": 81,
    "SPD": 95,
    "SPE": 95,
    "Species": 770
  },
  {
    "ATK": 100,
    "Abilities": [
      29,
      29,
      29
    ],
    "DEF": 150,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 50,
    "SPA": 100,
    "SPD": 150,
    "SPE": 50,
    "Species": 772
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 110,
    "Abilities": [
      11,
      11,
      11
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 130,
    "SPD": 90,
    "SPE": 70,
    "Species": 773
  },
  {
    "ATK": 55,
    "Abilities": [
      65,
      65,
      203
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 68,
    "SPA": 50,
    "SPD": 50,
    "SPE": 42,
    "Species": 841
  },
  {
    "ATK": 75,
    "Abilities": [
      65,
      65,
      203
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 78,
    "SPA": 70,
    "SPD": 70,
    "SPE": 52,
    "Species": 842
  },
  {
    "ATK": 107,
    "Abilities": [
      65,
      65,
      203
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 78,
    "SPA": 100,
    "SPD": 100,
    "SPE": 70,
    "Species": 843
  },
  {
    "ATK": 65,
    "Abilities": [
      66,
      66,
      22
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 45,
    "SPA": 60,
    "SPD": 40,
    "SPE": 70,
    "Species": 844
  },
  {
    "ATK": 85,
    "Abilities": [
      66,
      66,
      22
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 80,
    "SPD": 50,
    "SPE": 90,
    "Species": 845
  },
  {
    "ATK": 115,
    "Abilities": [
      66,
      66,
      22
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 95,
    "SPA": 80,
    "SPD": 90,
    "SPE": 60,
    "Species": 846
  },
  {
    "ATK": 54,
    "Abilities": [
      67,
      67,
      204
    ],
    "DEF": 54,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 50,
    "SPA": 66,
    "SPD": 56,
    "SPE": 40,
    "Species": 847
  },
  {
    "ATK": 69,
    "Abilities": [
      67,
      67,
      204
    ],
    "DEF": 69,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 60,
    "SPA": 91,
    "SPD": 81,
    "SPE": 50,
    "Species": 848
  },
  {
    "ATK": 74,
    "Abilities": [
      67,
      67,
      204
    ],
    "DEF": 74,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 80,
    "SPA": 126,
    "SPD": 116,
    "SPE": 60,
    "Species": 849
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 62,
    "Abilities": [
      68,
      68,
      68
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 47,
    "SPA": 55,
    "SPD": 45,
    "SPE": 46,
    "Species": 836
  },
  {
    "ATK": 82,
    "Abilities": [
      217,
      217,
      217
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 57,
    "SPA": 55,
    "SPD": 75,
    "SPE": 36,
    "Species": 837
  },
  {
    "ATK": 70,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 77,
    "SPA": 145,
    "SPD": 75,
    "SPE": 43,
    "Species": 838
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 45,
    "Abilities": [
      118,
      19,
      175
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 55,
    "SPD": 40,
    "SPE": 84,
    "Species": 834
  },
  {
    "ATK": 55,
    "Abilities": [
      118,
      19,
      175
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 95,
    "SPD": 70,
    "SPE": 124,
    "Species": 835
  },
  {
    "ATK": 65,
    "Abilities": [
      51,
      72,
      80
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 1131,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 45,
    "SPA": 30,
    "SPD": 40,
    "SPE": 60,
    "Species": 828
  },
  {
    "ATK": 115,
    "Abilities": [
      51,
      146,
      80
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1132,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 75,
    "SPA": 55,
    "SPD": 65,
    "SPE": 112,
    "Species": 829
  },
  {
    "ATK": 20,
    "Abilities": [
      208,
      208,
      208
    ],
    "DEF": 20,
    "FormIndex": 0,
    "FormStatsIndex": 1134,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 45,
    "SPA": 25,
    "SPD": 25,
    "SPE": 40,
    "Species": 820
  },
  {
    "ATK": 53,
    "Abilities": [
      196,
      7,
      144
    ],
    "DEF": 62,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 43,
    "SPD": 52,
    "SPE": 45,
    "Species": 801
  },
  {
    "ATK": 63,
    "Abilities": [
      196,
      7,
      144
    ],
    "DEF": 152,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 53,
    "SPD": 142,
    "SPE": 35,
    "Species": 802
  },
  {
    "ATK": 100,
    "Abilities": [
      20,
      192,
      39
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 45,
    "SPD": 55,
    "SPE": 45,
    "Species": 839
  },
  {
    "ATK": 125,
    "Abilities": [
      20,
      192,
      39
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 55,
    "SPD": 85,
    "SPE": 35,
    "Species": 840
  },
  {
    "ATK": 40,
    "Abilities": [
      199,
      199,
      11
    ],
    "DEF": 52,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 38,
    "SPA": 40,
    "SPD": 72,
    "SPE": 27,
    "Species": 850
  },
  {
    "ATK": 70,
    "Abilities": [
      199,
      199,
      11
    ],
    "DEF": 92,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 50,
    "SPD": 132,
    "SPE": 42,
    "Species": 851
  },
  {
    "ATK": 55,
    "Abilities": [
      102,
      102,
      126
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 50,
    "SPD": 35,
    "SPE": 35,
    "Species": 868
  },
  {
    "ATK": 105,
    "Abilities": [
      102,
      102,
      126
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 80,
    "SPD": 90,
    "SPE": 45,
    "Species": 869
  },
  {
    "ATK": 35,
    "Abilities": [
      35,
      27,
      44
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 65,
    "SPD": 75,
    "SPE": 15,
    "Species": 803
  },
  {
    "ATK": 45,
    "Abilities": [
      35,
      27,
      44
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 90,
    "SPD": 100,
    "SPE": 30,
    "Species": 804
  },
  {
    "ATK": 44,
    "Abilities": [
      212,
      212,
      12
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 48,
    "SPA": 71,
    "SPD": 40,
    "SPE": 77,
    "Species": 805
  },
  {
    "ATK": 64,
    "Abilities": [
      212,
      212,
      12
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 68,
    "SPA": 111,
    "SPD": 60,
    "SPE": 117,
    "Species": 806
  },
  {
    "ATK": 75,
    "Abilities": [
      218,
      103,
      56
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 45,
    "SPD": 50,
    "SPE": 50,
    "Species": 852
  },
  {
    "ATK": 125,
    "Abilities": [
      218,
      103,
      127
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 120,
    "SPA": 55,
    "SPD": 60,
    "SPE": 60,
    "Species": 853
  },
  {
    "ATK": 30,
    "Abilities": [
      102,
      12,
      175
    ],
    "DEF": 38,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 42,
    "SPA": 30,
    "SPD": 38,
    "SPE": 32,
    "Species": 812
  },
  {
    "ATK": 40,
    "Abilities": [
      102,
      12,
      175
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 52,
    "SPA": 40,
    "SPD": 48,
    "SPE": 62,
    "Species": 813
  },
  {
    "ATK": 120,
    "Abilities": [
      102,
      214,
      175
    ],
    "DEF": 98,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 72,
    "SPA": 50,
    "SPD": 98,
    "SPE": 72,
    "Species": 814
  },
  {
    "ATK": 52,
    "Abilities": [
      166,
      205,
      30
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 51,
    "SPA": 82,
    "SPD": 110,
    "SPE": 100,
    "Species": 863
  },
  {
    "ATK": 60,
    "Abilities": [
      39,
      140,
      180
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 90,
    "SPD": 110,
    "SPE": 60,
    "Species": 810
  },
  {
    "ATK": 120,
    "Abilities": [
      222,
      222,
      128
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 40,
    "SPD": 60,
    "SPE": 80,
    "Species": 815
  },
  {
    "ATK": 35,
    "Abilities": [
      193,
      193,
      193
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 25,
    "SPA": 20,
    "SPD": 30,
    "SPE": 80,
    "Species": 866
  },
  {
    "ATK": 125,
    "Abilities": [
      194,
      194,
      194
    ],
    "DEF": 140,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 60,
    "SPD": 90,
    "SPE": 40,
    "Species": 867
  },
  {
    "ATK": 55,
    "Abilities": [
      195,
      195,
      8
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 70,
    "SPD": 45,
    "SPE": 15,
    "Species": 822
  },
  {
    "ATK": 75,
    "Abilities": [
      195,
      195,
      8
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 85,
    "SPA": 100,
    "SPD": 75,
    "SPE": 35,
    "Species": 823
  },
  {
    "ATK": 60,
    "Abilities": [
      215,
      215,
      109
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 30,
    "SPD": 130,
    "SPE": 5,
    "Species": 821
  },
  {
    "ATK": 95,
    "Abilities": [
      4,
      4,
      4
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 59,
    "Species": 861
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 78,
    "Abilities": [
      75,
      75,
      75
    ],
    "DEF": 135,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 91,
    "SPD": 85,
    "SPE": 36,
    "Species": 854
  },
  {
    "ATK": 98,
    "Abilities": [
      160,
      31,
      5
    ],
    "DEF": 63,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 65,
    "SPA": 40,
    "SPD": 73,
    "SPE": 96,
    "Species": 858
  },
  {
    "ATK": 90,
    "Abilities": [
      209,
      209,
      209
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 1165,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 55,
    "SPA": 50,
    "SPD": 105,
    "SPE": 96,
    "Species": 819
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 60,
    "Abilities": [
      201,
      157,
      13
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 78,
    "SPA": 135,
    "SPD": 91,
    "SPE": 36,
    "Species": 856
  },
  {
    "ATK": 131,
    "Abilities": [
      200,
      200,
      200
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 70,
    "SPA": 86,
    "SPD": 90,
    "SPE": 40,
    "Species": 857
  },
  {
    "ATK": 55,
    "Abilities": [
      171,
      43,
      142
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 45,
    "SPA": 45,
    "SPD": 45,
    "SPE": 45,
    "Species": 816
  },
  {
    "ATK": 75,
    "Abilities": [
      171,
      43,
      142
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 55,
    "SPA": 65,
    "SPD": 70,
    "SPE": 65,
    "Species": 817
  },
  {
    "ATK": 110,
    "Abilities": [
      171,
      43,
      142
    ],
    "DEF": 125,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 75,
    "SPA": 100,
    "SPD": 105,
    "SPE": 85,
    "Species": 818
  },
  {
    "ATK": 115,
    "Abilities": [
      226,
      226,
      140
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 70,
    "SPA": 95,
    "SPD": 75,
    "SPE": 130,
    "Species": 830
  },
  {
    "ATK": 85,
    "Abilities": [
      227,
      227,
      140
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 70,
    "SPA": 130,
    "SPD": 115,
    "SPE": 95,
    "Species": 831
  },
  {
    "ATK": 130,
    "Abilities": [
      229,
      229,
      140
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 70,
    "SPA": 85,
    "SPD": 95,
    "SPE": 75,
    "Species": 832
  },
  {
    "ATK": 75,
    "Abilities": [
      228,
      228,
      140
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 70,
    "SPA": 95,
    "SPD": 130,
    "SPE": 85,
    "Species": 833
  },
  {
    "ATK": 29,
    "Abilities": [
      109,
      109,
      109
    ],
    "DEF": 31,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 43,
    "SPA": 29,
    "SPD": 31,
    "SPE": 37,
    "Species": 871
  },
  {
    "ATK": 29,
    "Abilities": [
      5,
      5,
      5
    ],
    "DEF": 131,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 43,
    "SPA": 29,
    "SPD": 131,
    "SPE": 37,
    "Species": 872
  },
  {
    "ATK": 137,
    "Abilities": [
      230,
      230,
      230
    ],
    "DEF": 107,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 137,
    "SPA": 113,
    "SPD": 89,
    "SPE": 97,
    "Species": 873
  },
  {
    "ATK": 113,
    "Abilities": [
      231,
      231,
      231
    ],
    "DEF": 89,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 137,
    "SPA": 137,
    "SPD": 107,
    "SPE": 97,
    "Species": 874
  },
  {
    "ATK": 53,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 47,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 109,
    "SPA": 127,
    "SPD": 131,
    "SPE": 103,
    "Species": 875
  },
  {
    "ATK": 139,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 139,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 107,
    "SPA": 53,
    "SPD": 53,
    "SPE": 79,
    "Species": 877
  },
  {
    "ATK": 137,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 37,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 71,
    "SPA": 137,
    "SPD": 37,
    "SPE": 151,
    "Species": 879
  },
  {
    "ATK": 89,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 71,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 83,
    "SPA": 173,
    "SPD": 71,
    "SPE": 83,
    "Species": 878
  },
  {
    "ATK": 101,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 103,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 97,
    "SPA": 107,
    "SPD": 101,
    "SPE": 61,
    "Species": 881
  },
  {
    "ATK": 181,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 131,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 59,
    "SPA": 59,
    "SPD": 31,
    "SPE": 109,
    "Species": 880
  },
  {
    "ATK": 101,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 53,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 223,
    "SPA": 97,
    "SPD": 53,
    "SPE": 43,
    "Species": 876
  },
  {
    "ATK": 107,
    "Abilities": [
      232,
      232,
      232
    ],
    "DEF": 101,
    "FormIndex": 0,
    "FormStatsIndex": 1166,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 97,
    "SPA": 127,
    "SPD": 89,
    "SPE": 79,
    "Species": 865
  },
  {
    "ATK": 95,
    "Abilities": [
      220,
      220,
      220
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 1168,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 80,
    "SPA": 130,
    "SPD": 115,
    "SPE": 65,
    "Species": 882
  },
  {
    "ATK": 125,
    "Abilities": [
      101,
      101,
      101
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 90,
    "SPD": 90,
    "SPE": 125,
    "Species": 883
  },
  {
    "ATK": 73,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 67,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 67,
    "SPA": 73,
    "SPD": 67,
    "SPE": 73,
    "Species": 886
  },
  {
    "ATK": 73,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 73,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 73,
    "SPA": 127,
    "SPD": 73,
    "SPE": 121,
    "Species": 887
  },
  {
    "ATK": 131,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 211,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 61,
    "SPA": 53,
    "SPD": 101,
    "SPE": 13,
    "Species": 884
  },
  {
    "ATK": 127,
    "Abilities": [
      224,
      224,
      224
    ],
    "DEF": 53,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 53,
    "SPA": 151,
    "SPD": 79,
    "SPE": 107,
    "Species": 885
  },
  {
    "ATK": 112,
    "Abilities": [
      10,
      10,
      10
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 88,
    "SPA": 102,
    "SPD": 80,
    "SPE": 143,
    "Species": 888
  },
  {
    "ATK": 65,
    "Abilities": [
      42,
      42,
      42
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 46,
    "SPA": 55,
    "SPD": 35,
    "SPE": 34,
    "Species": 891
  },
  {
    "ATK": 143,
    "Abilities": [
      89,
      89,
      89
    ],
    "DEF": 143,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 135,
    "SPA": 80,
    "SPD": 65,
    "SPE": 34,
    "Species": 892
  },
  {
    "ATK": 65,
    "Abilities": [
      65,
      65,
      229
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 50,
    "SPA": 40,
    "SPD": 40,
    "SPE": 65,
    "Species": 948
  },
  {
    "ATK": 85,
    "Abilities": [
      65,
      65,
      229
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 70,
    "SPA": 55,
    "SPD": 60,
    "SPE": 80,
    "Species": 949
  },
  {
    "ATK": 125,
    "Abilities": [
      65,
      65,
      229
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 100,
    "SPA": 60,
    "SPD": 70,
    "SPE": 85,
    "Species": 950
  },
  {
    "ATK": 71,
    "Abilities": [
      66,
      66,
      236
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 50,
    "SPA": 40,
    "SPD": 40,
    "SPE": 69,
    "Species": 954
  },
  {
    "ATK": 86,
    "Abilities": [
      66,
      66,
      236
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 55,
    "SPD": 60,
    "SPE": 94,
    "Species": 955
  },
  {
    "ATK": 116,
    "Abilities": [
      66,
      66,
      236
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 80,
    "SPA": 65,
    "SPD": 75,
    "SPE": 119,
    "Species": 956
  },
  {
    "ATK": 40,
    "Abilities": [
      67,
      67,
      97
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 50,
    "SPA": 70,
    "SPD": 40,
    "SPE": 70,
    "Species": 951
  },
  {
    "ATK": 60,
    "Abilities": [
      67,
      67,
      97
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 65,
    "SPA": 95,
    "SPD": 55,
    "SPE": 90,
    "Species": 952
  },
  {
    "ATK": 85,
    "Abilities": [
      67,
      67,
      97
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 70,
    "SPA": 125,
    "SPD": 65,
    "SPE": 120,
    "Species": 953
  },
  {
    "ATK": 55,
    "Abilities": [
      167,
      167,
      82
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 35,
    "SPD": 35,
    "SPE": 25,
    "Species": 909
  },
  {
    "ATK": 95,
    "Abilities": [
      167,
      167,
      82
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 120,
    "SPA": 55,
    "SPD": 75,
    "SPE": 20,
    "Species": 910
  },
  {
    "ATK": 47,
    "Abilities": [
      51,
      127,
      145
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 38,
    "SPA": 33,
    "SPD": 35,
    "SPE": 57,
    "Species": 918
  },
  {
    "ATK": 67,
    "Abilities": [
      51,
      127,
      145
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 43,
    "SPD": 55,
    "SPE": 77,
    "Species": 919
  },
  {
    "ATK": 87,
    "Abilities": [
      46,
      127,
      240
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 98,
    "SPA": 53,
    "SPD": 85,
    "SPE": 67,
    "Species": 920
  },
  {
    "ATK": 20,
    "Abilities": [
      68,
      14,
      140
    ],
    "DEF": 20,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 25,
    "SPA": 25,
    "SPD": 45,
    "SPE": 45,
    "Species": 930
  },
  {
    "ATK": 35,
    "Abilities": [
      68,
      14,
      140
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 50,
    "SPD": 90,
    "SPE": 30,
    "Species": 931
  },
  {
    "ATK": 45,
    "Abilities": [
      68,
      119,
      140
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 80,
    "SPD": 120,
    "SPE": 90,
    "Species": 932
  },
  {
    "ATK": 28,
    "Abilities": [
      50,
      84,
      198
    ],
    "DEF": 28,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 47,
    "SPD": 52,
    "SPE": 50,
    "Species": 901
  },
  {
    "ATK": 58,
    "Abilities": [
      50,
      84,
      198
    ],
    "DEF": 58,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 87,
    "SPD": 92,
    "SPE": 90,
    "Species": 902
  },
  {
    "ATK": 40,
    "Abilities": [
      238,
      144,
      27
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 40,
    "SPD": 60,
    "SPE": 10,
    "Species": 905
  },
  {
    "ATK": 50,
    "Abilities": [
      238,
      144,
      27
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 60,
    "SPA": 80,
    "SPD": 120,
    "SPE": 60,
    "Species": 906
  },
  {
    "ATK": 40,
    "Abilities": [
      218,
      50,
      171
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 42,
    "SPA": 40,
    "SPD": 45,
    "SPE": 48,
    "Species": 911
  },
  {
    "ATK": 80,
    "Abilities": [
      218,
      80,
      171
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 72,
    "SPA": 60,
    "SPD": 90,
    "SPE": 88,
    "Species": 912
  },
  {
    "ATK": 64,
    "Abilities": [
      173,
      75,
      33
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 38,
    "SPD": 38,
    "SPE": 44,
    "Species": 903
  },
  {
    "ATK": 115,
    "Abilities": [
      173,
      75,
      33
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 90,
    "SPA": 48,
    "SPD": 68,
    "SPE": 74,
    "Species": 904
  },
  {
    "ATK": 45,
    "Abilities": [
      237,
      237,
      155
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 59,
    "SPA": 40,
    "SPD": 50,
    "SPE": 26,
    "Species": 907
  },
  {
    "ATK": 90,
    "Abilities": [
      173,
      173,
      172
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 69,
    "SPA": 90,
    "SPD": 60,
    "SPE": 121,
    "Species": 908
  },
  {
    "ATK": 40,
    "Abilities": [
      243,
      85,
      18
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 40,
    "SPD": 50,
    "SPE": 30,
    "Species": 933
  },
  {
    "ATK": 60,
    "Abilities": [
      243,
      49,
      18
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 60,
    "SPD": 70,
    "SPE": 50,
    "Species": 934
  },
  {
    "ATK": 80,
    "Abilities": [
      243,
      49,
      18
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 80,
    "SPD": 90,
    "SPE": 30,
    "Species": 935
  },
  {
    "ATK": 40,
    "Abilities": [
      247,
      82,
      171
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 40,
    "SPD": 40,
    "SPE": 20,
    "Species": 966
  },
  {
    "ATK": 110,
    "Abilities": [
      247,
      82,
      55
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 95,
    "SPD": 60,
    "SPE": 70,
    "Species": 967
  },
  {
    "ATK": 85,
    "Abilities": [
      247,
      82,
      47
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 110,
    "SPA": 100,
    "SPD": 80,
    "SPE": 30,
    "Species": 968
  },
  {
    "ATK": 57,
    "Abilities": [
      245,
      61,
      8
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 52,
    "SPA": 35,
    "SPD": 50,
    "SPE": 46,
    "Species": 936
  },
  {
    "ATK": 107,
    "Abilities": [
      245,
      61,
      8
    ],
    "DEF": 125,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 72,
    "SPA": 65,
    "SPD": 70,
    "SPE": 71,
    "Species": 937
  },
  {
    "ATK": 85,
    "Abilities": [
      241,
      241,
      241
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 1169,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 70,
    "SPA": 85,
    "SPD": 95,
    "SPE": 85,
    "Species": 917
  },
  {
    "ATK": 63,
    "Abilities": [
      33,
      33,
      239
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 41,
    "SPA": 40,
    "SPD": 30,
    "SPE": 66,
    "Species": 913
  },
  {
    "ATK": 123,
    "Abilities": [
      33,
      33,
      239
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 61,
    "SPA": 60,
    "SPD": 50,
    "SPE": 136,
    "Species": 914
  },
  {
    "ATK": 38,
    "Abilities": [
      155,
      9,
      103
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 40,
    "SPA": 54,
    "SPD": 35,
    "SPE": 40,
    "Species": 921
  },
  {
    "ATK": 98,
    "Abilities": [
      244,
      57,
      101
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1171,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 75,
    "SPA": 114,
    "SPD": 70,
    "SPE": 75,
    "Species": 922
  },
  {
    "ATK": 65,
    "Abilities": [
      18,
      73,
      49
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 50,
    "SPD": 50,
    "SPE": 45,
    "Species": 915
  },
  {
    "ATK": 115,
    "Abilities": [
      18,
      73,
      49
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 90,
    "SPD": 90,
    "SPE": 65,
    "Species": 916
  },
  {
    "ATK": 68,
    "Abilities": [
      7,
      7,
      101
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 50,
    "SPA": 50,
    "SPD": 50,
    "SPE": 32,
    "Species": 964
  },
  {
    "ATK": 118,
    "Abilities": [
      7,
      7,
      101
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 70,
    "SPD": 80,
    "SPE": 42,
    "Species": 965
  },
  {
    "ATK": 45,
    "Abilities": [
      133,
      133,
      130
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 1172,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 40,
    "SPA": 74,
    "SPD": 54,
    "SPE": 50,
    "Species": 972
  },
  {
    "ATK": 65,
    "Abilities": [
      133,
      133,
      130
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1173,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 60,
    "SPA": 134,
    "SPD": 114,
    "SPE": 70,
    "Species": 973
  },
  {
    "ATK": 30,
    "Abilities": [
      131,
      107,
      156
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 42,
    "SPA": 56,
    "SPD": 53,
    "SPE": 39,
    "Species": 969
  },
  {
    "ATK": 40,
    "Abilities": [
      131,
      107,
      156
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 57,
    "SPA": 86,
    "SPD": 73,
    "SPE": 49,
    "Species": 970
  },
  {
    "ATK": 90,
    "Abilities": [
      131,
      107,
      156
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 57,
    "SPA": 136,
    "SPD": 103,
    "SPE": 29,
    "Species": 971
  },
  {
    "ATK": 45,
    "Abilities": [
      158,
      119,
      124
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 45,
    "SPA": 55,
    "SPD": 40,
    "SPE": 50,
    "Species": 957
  },
  {
    "ATK": 60,
    "Abilities": [
      158,
      119,
      124
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 65,
    "SPA": 75,
    "SPD": 55,
    "SPE": 70,
    "Species": 958
  },
  {
    "ATK": 120,
    "Abilities": [
      158,
      119,
      124
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 0,
    "HP": 95,
    "SPA": 95,
    "SPD": 75,
    "SPE": 60,
    "Species": 959
  },
  {
    "ATK": 90,
    "Abilities": [
      120,
      62,
      128
    ],
    "DEF": 101,
    "FormIndex": 1,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 93,
    "SPA": 60,
    "SPD": 81,
    "SPE": 95,
    "Species": 928
  },
  {
    "ATK": 110,
    "Abilities": [
      4,
      181,
      252
    ],
    "DEF": 100,
    "FormIndex": 2,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 50,
    "SPD": 60,
    "SPE": 50,
    "Species": 943
  },
  {
    "ATK": 95,
    "Abilities": [
      133,
      133,
      253
    ],
    "DEF": 50,
    "FormIndex": 1,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 191,
    "HP": 60,
    "SPA": 145,
    "SPD": 130,
    "SPE": 30,
    "Species": 947
  },
  {
    "ATK": 135,
    "Abilities": [
      80,
      80,
      113
    ],
    "DEF": 95,
    "FormIndex": 1,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 62,
    "SPA": 68,
    "SPD": 82,
    "SPE": 65,
    "Species": 981
  },
  {
    "ATK": 85,
    "Abilities": [
      77,
      251,
      115
    ],
    "DEF": 75,
    "FormIndex": 1,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 80,
    "SPA": 110,
    "SPD": 100,
    "SPE": 70,
    "Species": 980
  },
  {
    "ATK": 95,
    "Abilities": [
      254,
      254,
      254
    ],
    "DEF": 145,
    "FormIndex": 1,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 58,
    "SPA": 50,
    "SPD": 105,
    "SPE": 30,
    "Species": 979
  },
  {
    "ATK": 40,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 254,
    "HP": 45,
    "SPA": 50,
    "SPD": 61,
    "SPE": 34,
    "Species": 924
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 100,
    "Abilities": [
      4,
      4,
      128
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 65,
    "SPA": 70,
    "SPD": 60,
    "SPE": 75,
    "Species": 923
  },
  {
    "ATK": 101,
    "Abilities": [
      31,
      31,
      226
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 48,
    "SPA": 91,
    "SPD": 85,
    "SPE": 15,
    "Species": 944
  },
  {
    "ATK": 25,
    "Abilities": [
      19,
      19,
      246
    ],
    "DEF": 35,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 30,
    "SPA": 45,
    "SPD": 30,
    "SPE": 20,
    "Species": 945
  },
  {
    "ATK": 65,
    "Abilities": [
      19,
      19,
      246
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 125,
    "SPD": 90,
    "SPE": 65,
    "Species": 946
  },
  {
    "ATK": 125,
    "Abilities": [
      249,
      249,
      249
    ],
    "DEF": 135,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 100,
    "SPA": 20,
    "SPD": 20,
    "SPE": 70,
    "Species": 974
  },
  {
    "ATK": 80,
    "Abilities": [
      248,
      248,
      248
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 1182,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 75,
    "SPA": 65,
    "SPD": 90,
    "SPE": 50,
    "Species": 975
  },
  {
    "ATK": 65,
    "Abilities": [
      39,
      28,
      227
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 1183,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 60,
    "SPA": 105,
    "SPD": 95,
    "SPE": 95,
    "Species": 942
  },
  {
    "ATK": 95,
    "Abilities": [
      258,
      258,
      258
    ],
    "DEF": 58,
    "FormIndex": 0,
    "FormStatsIndex": 1184,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 58,
    "SPA": 70,
    "SPD": 58,
    "SPE": 97,
    "Species": 941
  },
  {
    "ATK": 80,
    "Abilities": [
      125,
      125,
      134
    ],
    "DEF": 49,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 72,
    "SPA": 40,
    "SPD": 49,
    "SPE": 40,
    "Species": 926
  },
  {
    "ATK": 130,
    "Abilities": [
      125,
      125,
      134
    ],
    "DEF": 69,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 122,
    "SPA": 80,
    "SPD": 69,
    "SPE": 30,
    "Species": 927
  },
  {
    "ATK": 100,
    "Abilities": [
      10,
      55,
      146
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 80,
    "SPD": 70,
    "SPE": 75,
    "Species": 960
  },
  {
    "ATK": 100,
    "Abilities": [
      10,
      9,
      202
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 90,
    "SPD": 80,
    "SPE": 55,
    "Species": 961
  },
  {
    "ATK": 90,
    "Abilities": [
      11,
      173,
      146
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 70,
    "SPD": 80,
    "SPE": 75,
    "Species": 962
  },
  {
    "ATK": 90,
    "Abilities": [
      11,
      115,
      202
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 90,
    "SPA": 80,
    "SPD": 90,
    "SPE": 55,
    "Species": 963
  },
  {
    "ATK": 95,
    "Abilities": [
      135,
      134,
      242
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 70,
    "SPA": 120,
    "SPD": 50,
    "SPE": 85,
    "Species": 929
  },
  {
    "ATK": 60,
    "Abilities": [
      29,
      151,
      130
    ],
    "DEF": 30,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 28,
    "SPA": 40,
    "SPD": 30,
    "SPE": 82,
    "Species": 976
  },
  {
    "ATK": 80,
    "Abilities": [
      29,
      151,
      130
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 68,
    "SPA": 60,
    "SPD": 50,
    "SPE": 102,
    "Species": 977
  },
  {
    "ATK": 120,
    "Abilities": [
      29,
      151,
      130
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 127,
    "HP": 88,
    "SPA": 100,
    "SPD": 75,
    "SPE": 142,
    "Species": 978
  },
  {
    "ATK": 130,
    "Abilities": [
      234,
      234,
      234
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 1185,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 92,
    "SPA": 80,
    "SPD": 115,
    "SPE": 138,
    "Species": 938
  },
  {
    "ATK": 130,
    "Abilities": [
      235,
      235,
      235
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 1186,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 92,
    "SPA": 80,
    "SPD": 115,
    "SPE": 138,
    "Species": 939
  },
  {
    "ATK": 85,
    "Abilities": [
      46,
      46,
      46
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1187,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 140,
    "SPA": 145,
    "SPD": 95,
    "SPE": 130,
    "Species": 940
  },
  {
    "ATK": 90,
    "Abilities": [
      39,
      39,
      39
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 31,
    "HP": 60,
    "SPA": 53,
    "SPD": 50,
    "SPE": 72,
    "Species": 982
  },
  {
    "ATK": 130,
    "Abilities": [
      260,
      260,
      260
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 1188,
    "FormeCount": 2,
    "Gender": 31,
    "HP": 100,
    "SPA": 63,
    "SPD": 60,
    "SPE": 97,
    "Species": 983
  },
  {
    "ATK": 120,
    "Abilities": [
      102,
      102,
      102
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 1189,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 105,
    "SPA": 70,
    "SPD": 95,
    "SPE": 105,
    "Species": 988
  },
  {
    "ATK": 100,
    "Abilities": [
      262,
      262,
      262
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 80,
    "SPA": 100,
    "SPD": 50,
    "SPE": 200,
    "Species": 989
  },
  {
    "ATK": 100,
    "Abilities": [
      263,
      263,
      263
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 200,
    "SPA": 100,
    "SPD": 50,
    "SPE": 80,
    "Species": 990
  },
  {
    "ATK": 145,
    "Abilities": [
      264,
      264,
      264
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 65,
    "SPD": 110,
    "SPE": 30,
    "Species": 984
  },
  {
    "ATK": 65,
    "Abilities": [
      265,
      265,
      265
    ],
    "DEF": 60,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 1,
    "Gender": 255,
    "HP": 100,
    "SPA": 145,
    "SPD": 80,
    "SPE": 130,
    "Species": 985
  },
  {
    "ATK": 80,
    "Abilities": [
      127,
      127,
      127
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 1190,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 100,
    "SPA": 80,
    "SPD": 80,
    "SPE": 80,
    "Species": 986
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      9,
      9,
      31
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 901,
    "FormeCount": 10,
    "Gender": 0,
    "HP": 35,
    "SPA": 50,
    "SPD": 50,
    "SPE": 90,
    "Species": 25
  },
  {
    "ATK": 85,
    "Abilities": [
      207,
      207,
      207
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 910,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 60,
    "SPA": 95,
    "SPD": 85,
    "SPE": 110,
    "Species": 26
  },
  {
    "ATK": 75,
    "Abilities": [
      81,
      81,
      202
    ],
    "DEF": 90,
    "FormIndex": 1,
    "FormStatsIndex": 911,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 50,
    "SPA": 10,
    "SPD": 35,
    "SPE": 40,
    "Species": 27
  },
  {
    "ATK": 100,
    "Abilities": [
      81,
      81,
      202
    ],
    "DEF": 120,
    "FormIndex": 1,
    "FormStatsIndex": 912,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 75,
    "SPA": 25,
    "SPD": 65,
    "SPE": 65,
    "Species": 28
  },
  {
    "ATK": 41,
    "Abilities": [
      81,
      81,
      117
    ],
    "DEF": 40,
    "FormIndex": 1,
    "FormStatsIndex": 913,
    "FormeCount": 2,
    "Gender": 191,
    "HP": 38,
    "SPA": 50,
    "SPD": 65,
    "SPE": 65,
    "Species": 37
  },
  {
    "ATK": 67,
    "Abilities": [
      81,
      81,
      117
    ],
    "DEF": 75,
    "FormIndex": 1,
    "FormStatsIndex": 914,
    "FormeCount": 2,
    "Gender": 191,
    "HP": 73,
    "SPA": 81,
    "SPD": 100,
    "SPE": 109,
    "Species": 38
  },
  {
    "ATK": 55,
    "Abilities": [
      8,
      221,
      159
    ],
    "DEF": 30,
    "FormIndex": 1,
    "FormStatsIndex": 915,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 10,
    "SPA": 35,
    "SPD": 45,
    "SPE": 90,
    "Species": 50
  },
  {
    "ATK": 100,
    "Abilities": [
      8,
      221,
      159
    ],
    "DEF": 60,
    "FormIndex": 1,
    "FormStatsIndex": 916,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 35,
    "SPA": 50,
    "SPD": 70,
    "SPE": 110,
    "Species": 51
  },
  {
    "ATK": 35,
    "Abilities": [
      53,
      101,
      155
    ],
    "DEF": 35,
    "FormIndex": 1,
    "FormStatsIndex": 917,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 40,
    "SPA": 50,
    "SPD": 40,
    "SPE": 90,
    "Species": 52
  },
  {
    "ATK": 65,
    "Abilities": [
      53,
      181,
      127
    ],
    "DEF": 55,
    "FormIndex": 2,
    "FormStatsIndex": 917,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 50,
    "SPA": 40,
    "SPD": 40,
    "SPE": 40,
    "Species": 52
  },
  {
    "ATK": 60,
    "Abilities": [
      169,
      101,
      155
    ],
    "DEF": 60,
    "FormIndex": 1,
    "FormStatsIndex": 919,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 65,
    "SPA": 75,
    "SPD": 65,
    "SPE": 115,
    "Species": 53
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 85,
    "Abilities": [
      50,
      257,
      107
    ],
    "DEF": 55,
    "FormIndex": 1,
    "FormStatsIndex": 923,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 50,
    "SPA": 65,
    "SPD": 65,
    "SPE": 90,
    "Species": 77
  },
  {
    "ATK": 100,
    "Abilities": [
      50,
      257,
      107
    ],
    "DEF": 70,
    "FormIndex": 1,
    "FormStatsIndex": 924,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 65,
    "SPA": 80,
    "SPD": 80,
    "SPE": 105,
    "Species": 78
  },
  {
    "ATK": 65,
    "Abilities": [
      82,
      20,
      144
    ],
    "DEF": 65,
    "FormIndex": 1,
    "FormStatsIndex": 925,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 90,
    "SPA": 40,
    "SPD": 40,
    "SPE": 15,
    "Species": 79
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 100,
    "Abilities": [
      259,
      20,
      144
    ],
    "DEF": 95,
    "FormIndex": 1,
    "FormStatsIndex": 926,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 95,
    "SPA": 100,
    "SPD": 70,
    "SPE": 30,
    "Species": 80
  },
  {
    "ATK": 95,
    "Abilities": [
      80,
      80,
      113
    ],
    "DEF": 55,
    "FormIndex": 1,
    "FormStatsIndex": 928,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 52,
    "SPA": 58,
    "SPD": 62,
    "SPE": 55,
    "Species": 83
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 105,
    "Abilities": [
      119,
      119,
      139
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 931,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 95,
    "SPA": 125,
    "SPD": 75,
    "SPE": 45,
    "Species": 103
  },
  {
    "ATK": 80,
    "Abilities": [
      130,
      31,
      69
    ],
    "DEF": 110,
    "FormIndex": 0,
    "FormStatsIndex": 932,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 60,
    "SPA": 50,
    "SPD": 80,
    "SPE": 45,
    "Species": 105
  },
  {
    "ATK": 90,
    "Abilities": [
      26,
      256,
      228
    ],
    "DEF": 120,
    "FormIndex": 0,
    "FormStatsIndex": 933,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 65,
    "SPA": 85,
    "SPD": 70,
    "SPE": 60,
    "Species": 110
  },
  {
    "ATK": 65,
    "Abilities": [
      72,
      251,
      115
    ],
    "DEF": 65,
    "FormIndex": 1,
    "FormStatsIndex": 934,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 50,
    "SPA": 90,
    "SPD": 90,
    "SPE": 100,
    "Species": 122
  },
  {
    "ATK": 85,
    "Abilities": [
      172,
      172,
      172
    ],
    "DEF": 85,
    "FormIndex": 0,
    "FormStatsIndex": 935,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 90,
    "SPA": 125,
    "SPD": 100,
    "SPE": 95,
    "Species": 144
  },
  {
    "ATK": 125,
    "Abilities": [
      128,
      128,
      128
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 936,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 90,
    "SPA": 85,
    "SPD": 90,
    "SPE": 100,
    "Species": 145
  },
  {
    "ATK": 85,
    "Abilities": [
      201,
      201,
      201
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 937,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 90,
    "SPA": 100,
    "SPD": 125,
    "SPE": 90,
    "Species": 146
  },
  {
    "ATK": 65,
    "Abilities": [
      261,
      20,
      144
    ],
    "DEF": 80,
    "FormIndex": 1,
    "FormStatsIndex": 938,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 95,
    "SPA": 110,
    "SPD": 110,
    "SPE": 30,
    "Species": 199
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 55,
    "Abilities": [
      133,
      133,
      130
    ],
    "DEF": 100,
    "FormIndex": 1,
    "FormStatsIndex": 966,
    "FormeCount": 2,
    "Gender": 191,
    "HP": 60,
    "SPA": 65,
    "SPD": 100,
    "SPE": 30,
    "Species": 222
  },
  {
    "ATK": 30,
    "Abilities": [
      53,
      82,
      95
    ],
    "DEF": 41,
    "FormIndex": 1,
    "FormStatsIndex": 967,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 38,
    "SPA": 30,
    "SPD": 41,
    "SPE": 60,
    "Species": 263
  },
  {
    "ATK": 70,
    "Abilities": [
      53,
      82,
      95
    ],
    "DEF": 61,
    "FormIndex": 1,
    "FormStatsIndex": 968,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 78,
    "SPA": 50,
    "SPD": 61,
    "SPE": 100,
    "Species": 264
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 60,
    "Abilities": [
      122,
      122,
      122
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 982,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 70,
    "SPA": 87,
    "SPD": 78,
    "SPE": 85,
    "Species": 421
  },
  {
    "ATK": 48,
    "Abilities": [
      60,
      114,
      159
    ],
    "DEF": 48,
    "FormIndex": 0,
    "FormStatsIndex": 983,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 76,
    "SPA": 57,
    "SPD": 62,
    "SPE": 34,
    "Species": 422
  },
  {
    "ATK": 83,
    "Abilities": [
      60,
      114,
      159
    ],
    "DEF": 68,
    "FormIndex": 0,
    "FormStatsIndex": 984,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 111,
    "SPA": 92,
    "SPD": 82,
    "SPE": 39,
    "Species": 423
  },
  {
    "ATK": 65,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 107,
    "FormIndex": 0,
    "FormStatsIndex": 985,
    "FormeCount": 6,
    "Gender": 255,
    "HP": 50,
    "SPA": 105,
    "SPD": 107,
    "SPE": 86,
    "Species": 479
  },
  {
    "ATK": 65,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 107,
    "FormIndex": 0,
    "FormStatsIndex": 985,
    "FormeCount": 6,
    "Gender": 255,
    "HP": 50,
    "SPA": 105,
    "SPD": 107,
    "SPE": 86,
    "Species": 479
  },
  {
    "ATK": 65,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 107,
    "FormIndex": 0,
    "FormStatsIndex": 985,
    "FormeCount": 6,
    "Gender": 255,
    "HP": 50,
    "SPA": 105,
    "SPD": 107,
    "SPE": 86,
    "Species": 479
  },
  {
    "ATK": 65,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 107,
    "FormIndex": 0,
    "FormStatsIndex": 985,
    "FormeCount": 6,
    "Gender": 255,
    "HP": 50,
    "SPA": 105,
    "SPD": 107,
    "SPE": 86,
    "Species": 479
  },
  {
    "ATK": 65,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 107,
    "FormIndex": 0,
    "FormStatsIndex": 985,
    "FormeCount": 6,
    "Gender": 255,
    "HP": 50,
    "SPA": 105,
    "SPD": 107,
    "SPE": 86,
    "Species": 479
  },
  {
    "ATK": 120,
    "Abilities": [
      26,
      26,
      26
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 990,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 150,
    "SPA": 120,
    "SPD": 100,
    "SPE": 90,
    "Species": 487
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 92,
    "Abilities": [
      69,
      91,
      104
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1009,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 70,
    "SPA": 80,
    "SPD": 55,
    "SPE": 98,
    "Species": 550
  },
  {
    "ATK": 90,
    "Abilities": [
      55,
      55,
      39
    ],
    "DEF": 45,
    "FormIndex": 1,
    "FormStatsIndex": 1010,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 70,
    "SPA": 15,
    "SPD": 45,
    "SPE": 50,
    "Species": 554
  },
  {
    "ATK": 30,
    "Abilities": [
      125,
      125,
      161
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 1011,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 105,
    "SPA": 140,
    "SPD": 105,
    "SPE": 55,
    "Species": 555
  },
  {
    "ATK": 140,
    "Abilities": [
      255,
      255,
      161
    ],
    "DEF": 55,
    "FormIndex": 1,
    "FormStatsIndex": 1011,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 105,
    "SPA": 30,
    "SPD": 55,
    "SPE": 95,
    "Species": 555
  },
  {
    "ATK": 160,
    "Abilities": [
      255,
      255,
      161
    ],
    "DEF": 55,
    "FormIndex": 1,
    "FormStatsIndex": 1011,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 105,
    "SPA": 30,
    "SPD": 55,
    "SPE": 135,
    "Species": 555
  },
  {
    "ATK": 55,
    "Abilities": [
      254,
      254,
      254
    ],
    "DEF": 85,
    "FormIndex": 1,
    "FormStatsIndex": 1014,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 38,
    "SPA": 30,
    "SPD": 65,
    "SPE": 30,
    "Species": 562
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 81,
    "Abilities": [
      250,
      250,
      250
    ],
    "DEF": 99,
    "FormIndex": 0,
    "FormStatsIndex": 1021,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 109,
    "SPA": 66,
    "SPD": 84,
    "SPE": 32,
    "Species": 618
  },
  {
    "ATK": 100,
    "Abilities": [
      144,
      144,
      144
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 1022,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 79,
    "SPA": 110,
    "SPD": 90,
    "SPE": 121,
    "Species": 641
  },
  {
    "ATK": 105,
    "Abilities": [
      10,
      10,
      10
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1023,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 79,
    "SPA": 145,
    "SPD": 80,
    "SPE": 101,
    "Species": 642
  },
  {
    "ATK": 145,
    "Abilities": [
      22,
      22,
      22
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 1024,
    "FormeCount": 2,
    "Gender": 0,
    "HP": 89,
    "SPA": 105,
    "SPD": 80,
    "SPE": 91,
    "Species": 645
  },
  {
    "ATK": 120,
    "Abilities": [
      163,
      163,
      163
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 1025,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 125,
    "SPA": 170,
    "SPD": 100,
    "SPE": 95,
    "Species": 646
  },
  {
    "ATK": 170,
    "Abilities": [
      164,
      164,
      164
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 1025,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 125,
    "SPA": 120,
    "SPD": 90,
    "SPE": 95,
    "Species": 646
  },
  {
    "ATK": 72,
    "Abilities": [
      154,
      154,
      154
    ],
    "DEF": 90,
    "FormIndex": 0,
    "FormStatsIndex": 1027,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 91,
    "SPA": 129,
    "SPD": 90,
    "SPE": 108,
    "Species": 647
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 120,
    "Abilities": [
      88,
      88,
      88
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1029,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 71,
    "SPA": 120,
    "SPD": 95,
    "SPE": 99,
    "Species": 649
  },
  {
    "ATK": 120,
    "Abilities": [
      88,
      88,
      88
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1029,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 71,
    "SPA": 120,
    "SPD": 95,
    "SPE": 99,
    "Species": 649
  },
  {
    "ATK": 120,
    "Abilities": [
      88,
      88,
      88
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1029,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 71,
    "SPA": 120,
    "SPD": 95,
    "SPE": 99,
    "Species": 649
  },
  {
    "ATK": 120,
    "Abilities": [
      88,
      88,
      88
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1029,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 71,
    "SPA": 120,
    "SPD": 95,
    "SPE": 99,
    "Species": 649
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 48,
    "Abilities": [
      51,
      151,
      172
    ],
    "DEF": 76,
    "FormIndex": 0,
    "FormStatsIndex": 1114,
    "FormeCount": 2,
    "Gender": 254,
    "HP": 74,
    "SPA": 83,
    "SPD": 81,
    "SPE": 104,
    "Species": 734
  },
  {
    "ATK": 140,
    "Abilities": [
      176,
      176,
      176
    ],
    "DEF": 50,
    "FormIndex": 0,
    "FormStatsIndex": 1115,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 60,
    "SPA": 140,
    "SPD": 50,
    "SPE": 60,
    "Species": 746
  },
  {
    "ATK": 66,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1116,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 44,
    "SPA": 44,
    "SPD": 55,
    "SPE": 56,
    "Species": 735
  },
  {
    "ATK": 66,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1116,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 54,
    "SPA": 44,
    "SPD": 55,
    "SPE": 46,
    "Species": 735
  },
  {
    "ATK": 66,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1116,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 59,
    "SPA": 44,
    "SPD": 55,
    "SPE": 41,
    "Species": 735
  },
  {
    "ATK": 85,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 122,
    "FormIndex": 0,
    "FormStatsIndex": 1119,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 55,
    "SPA": 58,
    "SPD": 75,
    "SPE": 99,
    "Species": 736
  },
  {
    "ATK": 95,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 122,
    "FormIndex": 0,
    "FormStatsIndex": 1119,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 75,
    "SPA": 58,
    "SPD": 75,
    "SPE": 69,
    "Species": 736
  },
  {
    "ATK": 100,
    "Abilities": [
      53,
      119,
      15
    ],
    "DEF": 122,
    "FormIndex": 0,
    "FormStatsIndex": 1119,
    "FormeCount": 4,
    "Gender": 127,
    "HP": 85,
    "SPA": 58,
    "SPD": 75,
    "SPE": 54,
    "Species": 736
  },
  {
    "ATK": 131,
    "Abilities": [
      187,
      187,
      187
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1122,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 126,
    "SPA": 131,
    "SPD": 98,
    "SPE": 99,
    "Species": 768
  },
  {
    "ATK": 100,
    "Abilities": [
      188,
      188,
      188
    ],
    "DEF": 71,
    "FormIndex": 0,
    "FormStatsIndex": 1123,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 54,
    "SPA": 61,
    "SPD": 85,
    "SPE": 115,
    "Species": 770
  },
  {
    "ATK": 100,
    "Abilities": [
      211,
      211,
      211
    ],
    "DEF": 71,
    "FormIndex": 0,
    "FormStatsIndex": 1123,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 54,
    "SPA": 61,
    "SPD": 85,
    "SPE": 115,
    "Species": 770
  },
  {
    "ATK": 100,
    "Abilities": [
      211,
      211,
      211
    ],
    "DEF": 121,
    "FormIndex": 0,
    "FormStatsIndex": 1123,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 108,
    "SPA": 81,
    "SPD": 95,
    "SPE": 95,
    "Species": 770
  },
  {
    "ATK": 100,
    "Abilities": [
      211,
      211,
      211
    ],
    "DEF": 121,
    "FormIndex": 0,
    "FormStatsIndex": 1123,
    "FormeCount": 5,
    "Gender": 255,
    "HP": 216,
    "SPA": 91,
    "SPD": 95,
    "SPE": 85,
    "Species": 770
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 65,
    "Abilities": [
      20,
      20,
      20
    ],
    "DEF": 40,
    "FormIndex": 0,
    "FormStatsIndex": 1131,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 45,
    "SPA": 30,
    "SPD": 40,
    "SPE": 60,
    "Species": 828
  },
  {
    "ATK": 115,
    "Abilities": [
      51,
      72,
      99
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1132,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 85,
    "SPA": 55,
    "SPD": 75,
    "SPE": 82,
    "Species": 829
  },
  {
    "ATK": 117,
    "Abilities": [
      181,
      181,
      181
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1132,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 75,
    "SPA": 55,
    "SPD": 65,
    "SPE": 110,
    "Species": 829
  },
  {
    "ATK": 140,
    "Abilities": [
      208,
      208,
      208
    ],
    "DEF": 130,
    "FormIndex": 0,
    "FormStatsIndex": 1134,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 45,
    "SPA": 140,
    "SPD": 135,
    "SPE": 30,
    "Species": 820
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 95,
    "Abilities": [
      225,
      225,
      225
    ],
    "DEF": 95,
    "FormIndex": 0,
    "FormStatsIndex": 1135,
    "FormeCount": 18,
    "Gender": 255,
    "HP": 95,
    "SPA": 95,
    "SPD": 95,
    "SPE": 95,
    "Species": 862
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 0,
    "Abilities": [
      0,
      0,
      0
    ],
    "DEF": 0,
    "FormIndex": 0,
    "FormStatsIndex": 0,
    "FormeCount": 0,
    "Gender": 255,
    "HP": 0,
    "SPA": 0,
    "SPD": 0,
    "SPE": 0,
    "Species": 0
  },
  {
    "ATK": 90,
    "Abilities": [
      209,
      209,
      209
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 1165,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 55,
    "SPA": 50,
    "SPD": 105,
    "SPE": 96,
    "Species": 819
  },
  {
    "ATK": 157,
    "Abilities": [
      232,
      232,
      232
    ],
    "DEF": 127,
    "FormIndex": 0,
    "FormStatsIndex": 1166,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 97,
    "SPA": 113,
    "SPD": 109,
    "SPE": 77,
    "Species": 865
  },
  {
    "ATK": 113,
    "Abilities": [
      232,
      232,
      232
    ],
    "DEF": 109,
    "FormIndex": 0,
    "FormStatsIndex": 1166,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 97,
    "SPA": 157,
    "SPD": 127,
    "SPE": 77,
    "Species": 865
  },
  {
    "ATK": 95,
    "Abilities": [
      220,
      220,
      220
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 1168,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 80,
    "SPA": 130,
    "SPD": 115,
    "SPE": 65,
    "Species": 882
  },
  {
    "ATK": 85,
    "Abilities": [
      241,
      241,
      241
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 1169,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 70,
    "SPA": 85,
    "SPD": 95,
    "SPE": 85,
    "Species": 917
  },
  {
    "ATK": 85,
    "Abilities": [
      241,
      241,
      241
    ],
    "DEF": 55,
    "FormIndex": 0,
    "FormStatsIndex": 1169,
    "FormeCount": 3,
    "Gender": 127,
    "HP": 70,
    "SPA": 85,
    "SPD": 95,
    "SPE": 85,
    "Species": 917
  },
  {
    "ATK": 98,
    "Abilities": [
      244,
      58,
      101
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1171,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 75,
    "SPA": 114,
    "SPD": 70,
    "SPE": 75,
    "Species": 922
  },
  {
    "ATK": 45,
    "Abilities": [
      133,
      133,
      130
    ],
    "DEF": 45,
    "FormIndex": 0,
    "FormStatsIndex": 1172,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 40,
    "SPA": 74,
    "SPD": 54,
    "SPE": 50,
    "Species": 972
  },
  {
    "ATK": 65,
    "Abilities": [
      133,
      133,
      130
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1173,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 60,
    "SPA": 134,
    "SPD": 114,
    "SPE": 70,
    "Species": 973
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 60,
    "Abilities": [
      175,
      175,
      165
    ],
    "DEF": 75,
    "FormIndex": 0,
    "FormStatsIndex": 1174,
    "FormeCount": 9,
    "Gender": 254,
    "HP": 65,
    "SPA": 110,
    "SPD": 121,
    "SPE": 64,
    "Species": 925
  },
  {
    "ATK": 80,
    "Abilities": [
      248,
      248,
      248
    ],
    "DEF": 70,
    "FormIndex": 0,
    "FormStatsIndex": 1182,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 75,
    "SPA": 65,
    "SPD": 50,
    "SPE": 130,
    "Species": 975
  },
  {
    "ATK": 55,
    "Abilities": [
      20,
      28,
      227
    ],
    "DEF": 65,
    "FormIndex": 0,
    "FormStatsIndex": 1183,
    "FormeCount": 2,
    "Gender": 254,
    "HP": 70,
    "SPA": 95,
    "SPD": 105,
    "SPE": 85,
    "Species": 942
  },
  {
    "ATK": 95,
    "Abilities": [
      258,
      258,
      258
    ],
    "DEF": 58,
    "FormIndex": 0,
    "FormStatsIndex": 1184,
    "FormeCount": 2,
    "Gender": 127,
    "HP": 58,
    "SPA": 70,
    "SPD": 58,
    "SPE": 97,
    "Species": 941
  },
  {
    "ATK": 170,
    "Abilities": [
      234,
      234,
      234
    ],
    "DEF": 115,
    "FormIndex": 0,
    "FormStatsIndex": 1185,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 92,
    "SPA": 80,
    "SPD": 115,
    "SPE": 148,
    "Species": 938
  },
  {
    "ATK": 130,
    "Abilities": [
      235,
      235,
      235
    ],
    "DEF": 145,
    "FormIndex": 0,
    "FormStatsIndex": 1186,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 92,
    "SPA": 80,
    "SPD": 145,
    "SPE": 128,
    "Species": 939
  },
  {
    "ATK": 115,
    "Abilities": [
      46,
      46,
      46
    ],
    "DEF": 250,
    "FormIndex": 0,
    "FormStatsIndex": 1187,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 255,
    "SPA": 125,
    "SPD": 250,
    "SPE": 130,
    "Species": 940
  },
  {
    "ATK": 130,
    "Abilities": [
      260,
      260,
      260
    ],
    "DEF": 100,
    "FormIndex": 0,
    "FormStatsIndex": 1188,
    "FormeCount": 2,
    "Gender": 31,
    "HP": 100,
    "SPA": 63,
    "SPD": 60,
    "SPE": 97,
    "Species": 983
  },
  {
    "ATK": 120,
    "Abilities": [
      102,
      102,
      102
    ],
    "DEF": 105,
    "FormIndex": 0,
    "FormStatsIndex": 1189,
    "FormeCount": 2,
    "Gender": 255,
    "HP": 105,
    "SPA": 70,
    "SPD": 95,
    "SPE": 105,
    "Species": 988
  },
  {
    "ATK": 165,
    "Abilities": [
      266,
      266,
      266
    ],
    "DEF": 150,
    "FormIndex": 0,
    "FormStatsIndex": 1190,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 100,
    "SPA": 85,
    "SPD": 130,
    "SPE": 50,
    "Species": 986
  },
  {
    "ATK": 85,
    "Abilities": [
      267,
      267,
      267
    ],
    "DEF": 80,
    "FormIndex": 0,
    "FormStatsIndex": 1190,
    "FormeCount": 3,
    "Gender": 255,
    "HP": 100,
    "SPA": 165,
    "SPD": 100,
    "SPE": 150,
    "Species": 986
  }
];


const getPkmn = (pkmn, form) => {
  return pkdex[getPkmnIdx(pkmn, form)];
}

const getPkmnIdx = (pkmn, form) => {
  let base = pkdex[pkmn];
  if(form <= 0) {
      return pkmn;
  }
  if(base.FormStatsIndex <= 0) {
      return pkmn;
  } 
  if(form >= base.FormeCount) {
      return pkmn;
  }
  return base.FormStatsIndex + form - 1;
}

export default getPkmn;

export {getPkmn, getPkmnIdx};